import React, { ReactElement, Suspense, useEffect, useReducer, useRef, useState } from 'react';
import { Page, ContextualSaveBar, Modal, Badge, Button, BlockStack, InlineStack, Text, Icon, Image, List, Box, Banner, Card, Layout } from '@shopify/polaris';
import { DI, DIProps } from '../../../Core';
import { StateContext } from './Context/StateContext';
import { DispatchContext } from './Context/DispatchContext';
import { reducer } from './Context/reducer';
import { initialProductEditState } from './Context/helper';
import { getcategoryttributes, getproduct, getproductattributes, saveproduct } from './editproductapihelper';
import { defaultImage, getModalStructure, productType, structuredProductData, validator, getAndSetDefaultValues, AVAILABLE_FOR_OFFER, renderFooter, isPageLoading, extractCurrencySettings, getErrorBySectionName, prepareProductAttributes, duplicateSKUValidator, isSectionVisible, getLocalsellingWarehouseData, getAmazonLink, businessPriceValidator, priceValidator, quantityValidator, getSanitizedPrice, compareObjects, errorCodeToMessage, errorCodeToAttribute, getSanitizedQuantity } from './utils/utils';
import CustomHeader from './utils/CustomHeader';
import queryString from 'query-string';
import { ACTION_TYPE } from './Context/actiontypes';
import { ContainerState } from './Context/ContainerState';
import { AmazonCategorySkeleton, AmazonSkuSkeleton, BarCodeSkeleton, BusinessPriceSkeleton, DescriptionSkeleton, FulfilmentTypeSkeleton, FullPageLoader, HandlingTimeSkeleton, InventorySkeleton, NewImageSkeleton, PriceSkeleton, ProductTitleSkeleton, variantGridSkeleton } from './utils/Skeleton';
import { getAmazonStatus } from '../Settings/Template/Components/FilterProducts/FilterProductsHelper';
import { environment } from '../../../environments/environment';
import useContextualSaveBar, { isAdminLoggedIn } from '../Panel/index';
import { formatQuantityExtended } from './components/quantity/quantityHelper';
import { getStatusFormatted } from './utils/statusHelper';
import { newFormattedStatus as prepareParentStatus } from '../Listing Grid/Utilities/Helper';
import LoadingE from './components/Customcomponents/Components/Loading';
import { scope } from './utils/customHelperFunctions';
import FulfillmentType from './components/FulfillmentType/FulfillmentType';
import { Provider } from '../../../Actions/NecessaryFun';
import { ExternalMinor, MobilePlusMajor } from '@shopify/polaris-icons';
import './utils/skeleton.css'
import './css/styles.css';
import EditTour from './EditTour';
import { useTour } from '../../Other/tour';
const Title = React.lazy(() => import('./components/Title/Title'));
const Descriptions = React.lazy(() => import('./components/Description/Description'));
const HandlingTimes = React.lazy(() => import('./components/HandlingTime/HandlingTime'));
const PriceN = React.lazy(() => import('./components/Price/PriceN'));
const BusinessPriceN = React.lazy(() => import('./components/BusinessPrice/BusinessPriceN'));
// const Quantitys = React.lazy(() => import('./components/quantity/Quantity'));
const AmazonParentSkus = React.lazy(() => import('./components/AmazonParentSku/AmazonParentSku'));
const BarcodeExemptions = React.lazy(() => import('./components/BarcodeExemption/BarcodeExemption'));
const QuantityN = React.lazy(() => import('./components/quantity/QuantityN'));
// const Images = React.lazy(() => import('./components/Image/Image'));
const UpdatedImage = React.lazy(() => import('./components/updatedImage/UpdatedImage'));
import { AmazonIcon, ShopifyIcon } from '../../../Asests/svgIcon/icon';
const JSONFeedAttributes = React.lazy(() => import('../JSONFeedNew/JSONFeedAttributes'));
import { HandleJSONFeedSaveT, JSONFeedBackendDataI } from '../JSONFeedNew/interface';
import { jsonAttributesSkeleton } from '../Settings/Template/Components/skeleton/Skeleton';
import TopTabs from './TopTabs';
import { useTranslation } from 'react-i18next';
import { RenderHeadersAction } from '../Panel';
import RefreshAttributes from '../../../Asests/Images/refresh_attributes.png'
import VariantsGrid from './components/VariantsGridCopy/VariantsGrid';
import ProductErrorsN from './components/ProductDetails/ProductErrorsN';
import ProductWarningsN from './components/ProductDetails/ProductWarningsN';
import ProductTypeSelector from './components/ProductTypeSelector/ProductTypeSelector';

let { hasLength } = scope;

interface Props extends DIProps {
  syncNecessaryInfo: () => void;
  syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
  syncProfileInfo: () => void;
  loginStatus: () => void;
  syncServices: () => void;
}

function Editproduct(props: Props): ReactElement {
  const [otherAttributeErrors, setOtherAttributeErrors] = useState<Record<string, string | null>>({});
  const [variantsValueMapping, setVariantsValueMapping] = useState<any>({});
  const [variantsValueMappingInit, setVariantsValueMappingInit] = useState<any>({});
  const defaultPrice = {
    attribute: "", //shopify, custom, price_increase, price_decrease, value_increase, value_decrease
    value: "",
    price_roundoff_value: ""
  }

  const defaultInventory = {
    "continue_selling": {
      "enabled": true,
      "value": "999"
    },
    "effective_inventory": {
      "enabled": false,
      "type": "none",
      "value": ""
    },
    "attribute": "effective", //default for shopify, custom for custom inventory, effective for custom rules
    "value": "",
  }

  const { t } = useTranslation();
  const [hasChanged, setHasChanged] = useState(false); // State to track description changes

  const [exceededFiles, setExceededFiles] = useState<string[]>([]);
  const [businessPriceErrors, setBusinessPriceErrors] = useState<any>({
    selectionType: false,
    attribute: false,
    value: false,
    quantity_type: false,
    fixed: [{ quantity: false, price: false, touched: { quantity: false, price: false } }],
    percent: [{ quantity: false, price: false, touched: { quantity: false, price: false } }],
  })
  const [showBusinessPrice, setShowBusinessPrice] = useState<boolean>(false);
  const [priceErrors, setPriceErrors] = useState<any>({
    attribute: false,
    value: false,
  });
  const [quantityErrors, setQuantityErrors] = useState<any>({
    effective_inventory: false,
    fixed_inventory: false,
    reserved_inventory: false,
    threshold_inventory: false,
    warehouses: false,
    value: false,
    attribute: false
  });
  const { setIsOpen, setCurrentStep, currentStep, isOpen, setTourLoading } = useTour()
  const [state, dispatch] = useReducer(reducer, {});
  const [componentState, setComponentState] = useState<any>({
    ...initialProductEditState,
    mutatedKeys: {},
    showSavebar: false,
    loaders: {
      required_attribute: false,
      fullPage: false,
      all_categories: false,
      searchCategory: false,
      uploadImages: false,
      shopify_attribute: false
    },
  });
  const ref = useRef();
  const { showSaveBar, hideSaveBar } = useContextualSaveBar(props);
  const titleRef = useRef<any>(null);
  const descriptionRef = useRef<any>(null);
  const priceRef = useRef<any>(null);
  const inventoryRef = useRef<any>(null);
  const businessPriceRef = useRef<any>(null);
  const barcodeRef = useRef<any>(null);
  const skuRef = useRef<any>(null);
  const productTypeRef = useRef<any>(null);
  const categoryRef = useRef<any>(null);
  const variationRef = useRef<any>(null);
  const variantGridRef = useRef<any>(null)
  const imageRef = useRef<any>(null);
  const image = useRef<any>(null);
  const inventory_fulfillment_latency = useRef<any>(null);
  const [attributeLoader, setAttributeLoader] = useState<boolean>(false);
  const [viewProductError, setViewProductError] = useState<boolean>(false);
  const [viewProductWarning, setViewProductWarning] = useState<boolean>(false);
  const style: any = { border: "2px solid red" }

  // States and refs for JSONATTRIBUTES
  const JSONFeedRef = useRef<HandleJSONFeedSaveT>(null);
  const [categoryProductType, setCategoryProductType] = useState<CategoryProductTypeI>({
    product_type: '',
    init_product_type: '',
    suggested_product_types: [],
    loadingSuggestions: false,
    selection_type: 'custom',
    init_selection_type: "custom",
    category_data: {}
  })
  const [JSONFeedAttributesData, setJSONFeedAttributesData] = useState<any>();
  const [renderJSONFeed, setRenderJSONFeed] = useState(false);
  const [showToastForLongLoading, setShowToastForLongLoading] = useState(false);
  const [allProductTypes, setAllProductTypes] = useState<string[]>([]);
  const [moreActionsData, setMoreActionsData] = useState<{ key: 'upload' | 'amazonLookup' | null, confirmationData: string | React.ReactNode, loader: boolean }>({ key: null, confirmationData: '', loader: false })
  const [validatorErrAfterSave, setValidatorErrorAfterSave] = useState<any>([])
  const defaultBusinessPrice = {
    quantity_type: "",
    percent: [{
      "quantity": "",
      "price": ""
    },
    ],
    fixed: [{
      "quantity": "",
      "price": ""
    }],
    attribute: "",
    value: "",
    selection_type: "custom",
    price_roundoff_value: "",
  }

  // new code for variants value mapping
  useEffect(() => {
    onSaveBarChange(!compareObjects(variantsValueMappingInit, variantsValueMapping), "variantsValueMapping")
  }, [variantsValueMapping, variantsValueMappingInit]);

  useEffect(() => {
    getParams();
    getProduct();
  }, []);

  useEffect(() => {
    return () => {
      if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) hideSaveBar();
    };
  }, []);

  const getAllProductTypes = () => {
    return props.di.POST('amazon/request/getAllProductTypes', {
      "target": {
        marketplace: props?.redux?.current?.target?.marketplace ?? '',
        shopId: props?.redux?.current?.target?._id ?? '',
      },
      "source": {
        marketplace: props?.redux?.current?.source?.marketplace ?? '',
        shopId: props?.redux?.current?.source?._id ?? '',
      }
    })
  }

  async function getPoductAttributes(product_data: any) {
    loaderHandler('shopify_attribute', true);
    let params: any = {};
    let type = 'variation'
    if (product_data.length === 1 && product_data[0]?.visibility === 'Catalog and Search') {
      type = 'simple'
    }
    params = {
      source: {
        marketplace: 'shopify',
        shopId: props.redux.current.source._id,
      },
      type,
      container_id: props?.match?.c_id
    };
    let { success, data } = await getproductattributes(props, params);
    if (success) {
      let temp: any = [];
      Object.keys(data)?.map((ele: any) => {
        temp.push({
          label: ele,
          options: prepareProductAttributes(data[ele])
        });
      });
      let parent = product_data?.filter((prod: any) => prod.visibility === "Catalog and Search")
      let products_value_on_shopify: any = {};
      product_data?.map((prod: any) => {
        Object.values(data).map((data_value: any) => {
          data_value.map((val: any) => {
            let value =
              prod?.[val.code] ??
              prod?.variantMetafield?.[val?.code]?.value ??
              prod?.parent_details?.parentMetafield?.[val?.code]?.value ??
              parent?.[0]?.parentMetafield?.[val?.code]?.value ??
              prod?.variant_attributes?.find((var_attr: any) => var_attr?.key === val?.code)?.value ?? null;
            if (Array.isArray(value)) {
              value = value.join(', ')
            }
            if (value !== undefined && value !== null) {
              products_value_on_shopify = {
                ...products_value_on_shopify,
                [prod?.source_product_id]: {
                  ...products_value_on_shopify?.[prod?.source_product_id] ?? {},
                  [val.code]: value
                }
              }
            }
          })
        })
      })
      dispatch({
        type: ACTION_TYPE.PRODUCTS_VALUE_ON_SHOPIFY,
        payload: { products_value_on_shopify }
      })

      componentState['product_attributes'] = temp;
      setComponentState({ ...componentState });
    } else props.error(t('Unable to get Shopify Attributes!'));
    loaderHandler('shopify_attribute', false)
  }

  async function getLocalSellingWarehouses() {
    let { success, data } = await props.di.GET('amazon/localselling/getAllStores');
    if (success) {
      return data;
    } else {
      return [];
    }
  }

  useEffect(() => {
    if (categoryProductType?.product_type_changed && categoryProductType?.product_type_changed?.includes('without_params')) {
      getCategoryAttributes();
    }
  }, [categoryProductType?.product_type_changed])

  function loaderHandler(type: string = '', value: boolean = false) {
    componentState['loaders'][type] = value;
    setComponentState({ ...componentState });
  }

  async function getCategoryAttributes(product_type_data = categoryProductType, barcode_exemption = state?.data?.barcode_exemption ?? false) {
    setValidatorErrorAfterSave([]);
    setOtherAttributeErrors({});
    setAttributeLoader(true);
    if (isOpen) {
      setTourLoading(true)
    }
    if (product_type_data?.product_type) {
      loaderHandler('required_attribute', true);
      let params: any = [];

      params = {
        target: {
          marketplace: 'amazon',
          shopId: props.redux.current.target._id,
        },
        source: {
          marketplace: 'shopify',
          shopId: props.redux.current.source._id,
        },
        data: {
          barcode_exemption,
          product_type: product_type_data.product_type,
          show_category: true
        },
      };
      let { success, data: attributesData } = await getcategoryttributes(
        props,
        params
      );
      if (success) {
        if (attributesData?.json_listing) {
          setJSONFeedAttributesData({ attributes: attributesData?.attributes, marketplace_id: attributesData?.marketplace_id, language_tag: attributesData?.language_tag })
          setRenderJSONFeed(true);
          [(componentState.category_attributes_rendering = false)];
        }
        else {
          setJSONFeedAttributesData(undefined)
          setRenderJSONFeed(false);
        }
        setShowToastForLongLoading(false);
      }
      else {
        setShowToastForLongLoading(true);
        props.error(t('Error while fetching attributes!'));
      }
      loaderHandler('required_attribute', false);
      setAttributeLoader(false);
      if (isOpen) {
        setTourLoading(false)
      }
    } else {
      setAttributeLoader(false)
    }
  }

  function getParams() {
    const queryParams: any = queryString.parse(props.location.search);
    let { container_id } = queryParams;
    if (container_id) {
      componentState.initialProductData.container_id = container_id;
      setComponentState({ ...componentState });
    } else {
      let { c_id } = props.match;
      componentState.initialProductData.container_id = c_id;
      setComponentState({ ...componentState });
    }
  }

  useEffect(() => { //for tracking description changes
    onSaveBarChange(hasChanged, "description")
  }, [hasChanged]);

  function setContextKeys(field: string = '', value: any) {
    return { [field]: value, };
  }

  function onSaveBarChange(data: any = {}, field: any) {
    if (field) {
      setComponentState((prev: any) => ({
        ...prev,
        mutatedKeys: {
          ...prev?.mutatedKeys ?? {},
          [field]: data,
        },
        showSavebar: Object.values(
          { ...prev?.mutatedKeys, [field]: data }
        ).includes(true)
      }));
    }
  }

  if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) {
    let savebar_options: any = {
      loading: componentState?.['loaders']?.['saveProduct'],
      closeSaveBar: state?.['hasError'],
      attributesLoader: attributeLoader
    };
    if (Object.values(componentState['mutatedKeys']).includes(true)) {
      (componentState['showSavebar'] || hasChanged) &&
        showSaveBar(onDiscard, saveProductData, { ...savebar_options });
    } else hideSaveBar();
  }

  function getUniqueProductId(handleVariantSourceProdId?: string) {
    let { s_id } = props.match;
    if (s_id) {
      componentState['product_type']['variantEdit'] = true;
      setComponentState({ ...componentState });
      if (handleVariantSourceProdId)
        return {
          container_id: componentState.initialProductData.container_id,
          source_product_id: handleVariantSourceProdId
        }
      else
        return {
          container_id: componentState.initialProductData.container_id,
          source_product_id: s_id
        };
    } else {
      let s_id = props?.location?.state?.source_product_id ?? "";
      componentState['product_type']['variantEdit'] = false;
      setComponentState({ ...componentState });
      return {
        container_id: componentState.initialProductData.container_id,
        source_product_id: s_id
      };
    }
  }

  function getFulfillmentType(profileInfo: any) {
    let fulfillmentType: string = "FBM";
    profileInfo?.data?.map((singleData: any) => {
      if (singleData?.data_type == "fulfillment_settings") {
        fulfillmentType = singleData?.data?.fulfillment_type ?? "FBM";
      }
    })
    return fulfillmentType;
  }

  const validateBusinessPriceErrors = (data: any, businessPriceEnabled: boolean) => {
    const errData: any = { ...businessPriceErrors }
    let hasError: boolean = false;
    if (businessPriceEnabled) {
      if (data['selection_type'] == "") {
        hasError = true
        errData['selectionType'] = data['selection_type'] == "";
      }
      if (businessPriceEnabled && data['selection_type'] == "custom") {
        if (data['attribute'] == "") {
          hasError = true;
          errData['attribute'] = data['attribute'] == "";
        }
        if (data['value'] == "") {
          hasError = true;
          errData['value'] = data['value'] == "";
        }
        if (showBusinessPrice) {
          if (data['quantity_type'] == "") {
            hasError = true
            errData['quantity_type'] = data['quantity_type'] == "";
          }
          if (data['quantity_type'] && data['quantity_type'] != "") {
            data[data?.quantity_type]?.map((discountRow: any, ind: number) => {
              if (discountRow?.quantity == "") {
                hasError = true;
                errData[data.quantity_type][ind]['quantity'] = true;
              }
              if (discountRow?.price == "") {
                hasError = true;
                errData[data.quantity_type][ind]['price'] = true;
              }
            })
          }
        }
      }
    }
  }

  function getProductTypeSuggestions(title: string, source_product_id: string, prev_product_type: string) {
    setCategoryProductType((prev) => ({ ...prev, loadingSuggestions: true }));
    props.di.POST("amazon/product/getProductTypeforTitle", {
      target: {
        marketplace: props?.redux?.current?.target?.marketplace ?? '',
        shopId: props?.redux?.current?.target?._id ?? '',
      },
      source: {
        marketplace: props?.redux?.current?.source?.marketplace ?? '',
        shopId: props?.redux?.current?.source?._id ?? '',
      },
      title,
      source_product_id
    }).then((res) => {
      if (res?.success) {
        let product_type: string = "";
        if (!prev_product_type && res?.data?.length === 1) {
          product_type = res?.data?.[0];
        }
        setCategoryProductType((prev) => ({
          ...prev,
          suggested_product_types: res?.data ?? [],
          loadingSuggestions: false,
          ...!!product_type ? { product_type: product_type, product_type_changed: product_type + "without_params" } : {}
        }));
      } else {
        setCategoryProductType((prev) => ({ ...prev, suggested_product_types: [], loadingSuggestions: false }))
      }
    })
  }

  async function getProduct(handleVariantSourceProdId?: string) {
    let { source, target } = props.redux.current;
    let params: any = {};
    if (handleVariantSourceProdId !== undefined) {
      params = {
        target_marketplace: 'amazon',
        source_marketplace: 'shopify',
        sourceShopID: source._id,
        targetShopID: target._id,
        ...getUniqueProductId(handleVariantSourceProdId),
      };
    } else {
      params = {
        target_marketplace: 'amazon',
        source_marketplace: 'shopify',
        sourceShopID: source._id,
        targetShopID: target._id,
        ...getUniqueProductId(),
      };
    }
    loaderHandler('fullPage', true);
    let { success, data } = await getproduct(props, params);
    await getPoductAttributes(data.rows);
    let modified_product: any = { ...state.initialComponentState, onSaveBarChange, data: {} };
    let defatulProfileSettings: any = [];
    if (success && data.rows.length > 0) {
      componentState.initialProductData['productLength'] = data.rows.length;
      let { success, data: defaultSettings, } = await props.di.POST('connector/config/getConfig', { group_code: ['price', 'inventory', 'currency', 'order', 'tour'] });
      defaultSettings = defaultSettings?.map((setting: any) => {
        return { ...setting, key: setting?.group_code ?? '' }
      })
      let localsellingStore: any = await getLocalSellingWarehouses();
      if (success) defatulProfileSettings = defaultSettings;
      for (const element of data?.rows) {
        let { container_id, edited, title, price, quantity, barcode, main_image, description, additional_images, source_product_id, profile_info, sku, type, parent_details, variant_attributes, locations, inventory_management, inventory_policy, visibility, variant_title } = element;
        let isParent: boolean = false;
        isParent = productType(element);
        if (isParent || data?.['rows']?.length === 1) {
          let { duplicateSKU, isDuplicateSKUExists } = duplicateSKUValidator(isParent ? element?.marketplace : element?.parent_details?.marketplace, source_product_id);
          if (isDuplicateSKUExists) {
            props.error(t('Duplicate SKU : ') + duplicateSKU + t(' found in variants'))
          }
          componentState.initialProductData.source_product_id = source_product_id;
          componentState.initialProductData.type = type;
          componentState.initialProductData.asin = edited?.['asin'] ?? '';
          componentState.initialProductData.viewOnShopify = `https://${props.di.globalState.get('shop'
          )}/admin/products/${container_id}`;
          componentState.initialProductData['title'] = visibility === "Catalog and Search" ? title : variant_title;
          componentState.initialProductData['main_image'] = main_image;
          componentState.initialProductData['hasVariants'] = type === 'simple';
          componentState.initialProductData['variant_attributes'] = variant_attributes;

          //new code flow for variants mapping
          if (edited && edited?.category_settings && edited?.category_settings?.variants_value_mapping) {
            setVariantsValueMapping(edited?.category_settings?.variants_value_mapping ?? {});
            setVariantsValueMappingInit(edited?.category_settings?.variants_value_mapping ?? {});
          }

          let tempStatus: any =
            visibility === "Catalog and Search" ?
              prepareParentStatus(props.location?.state?.['status'], {
                sourceShopID: source['_id'], targetShopID: target['_id'],
              }) :
              getStatusFormatted(element, {
                sourceShopID: source['_id'], targetShopID: target['_id'],
              });
          componentState.initialProductData['status'] = tempStatus?.['label'];

          let categ_product_type_data: typeof categoryProductType = { ...categoryProductType };

          //---------------------------------------- Handle product type of variant edit--------------------------------------
          if (componentState?.product_type?.variantEdit) {
            if (componentState.initialProductData['status'] === AVAILABLE_FOR_OFFER) { // Handle Varaint edit for offer listing
              categ_product_type_data = {
                product_type: 'PRODUCT',
                init_product_type: 'PRODUCT',
                from: 'edited',
                suggested_product_types: [],
                loadingSuggestions: false,
                selection_type: 'custom',
                init_selection_type: 'custom',
                category_data: {},
                getData: edited?.edited_variant_jsonFeed ?? {},
                currentData: edited?.edited_variant_jsonFeed ?? {},
              };
            } else {
              const { edited: parent_details_edited, profile_info: parent_details_profile_info } = parent_details; // Take edited and profile info from parent details
              // Pick Product Type from parent details edited or profile_info or variant's profile info
              const pick_product_type = parent_details_edited?.category_settings?.product_type ?? parent_details_profile_info?.category_settings?.product_type ?? profile_info?.category_settings?.product_type ?? "";

              categ_product_type_data = {
                product_type: pick_product_type,
                init_product_type: pick_product_type,
                getData: edited?.edited_variant_jsonFeed ?? {},
                currentData: edited?.edited_variant_jsonFeed ?? {},
                from: 'edited',
                suggested_product_types: [],
                loadingSuggestions: false,
                selection_type: 'custom',
                init_selection_type: 'custom',
                category_data: {}
              }
            }
          }
          //--------------------------------------- Handle product type for parent edit-----------------------------------------------
          else {
            if (componentState.initialProductData['status'] === AVAILABLE_FOR_OFFER) {
              const pick_attr_data = edited?.category_settings?.product_type === "PRODUCT" ? // If edited has product_type as PRODUCT
                edited?.category_settings?.attributes_mapping?.jsonFeed : //then pick attributes from edited
                profile_info?.category_settings?.product_type === "PRODUCT" ? // If profile_info has product_type as PRODUCT
                  profile_info?.attributes_mapping?.data?.jsonFeed  //then pick attributes from profile_info
                  : {};
              categ_product_type_data = {
                product_type: 'PRODUCT',
                init_product_type: 'PRODUCT',
                getData: pick_attr_data,
                currentData: pick_attr_data,
                from: 'edited',
                suggested_product_types: [],
                loadingSuggestions: false,
                selection_type: 'custom',
                init_selection_type: 'custom',
                category_data: {},
              };
            } else {
              if (!!edited?.category_settings?.product_type) { //If edited has product_type
                categ_product_type_data = {
                  product_type: edited?.category_settings?.product_type,
                  init_product_type: edited?.category_settings?.product_type,
                  getData: edited?.category_settings?.attributes_mapping?.jsonFeed,
                  currentData: edited?.category_settings?.attributes_mapping?.jsonFeed,
                  from: 'edited',
                  suggested_product_types: [],
                  loadingSuggestions: false,
                  selection_type: 'custom',
                  init_selection_type: 'custom',
                  category_data: {
                    browse_node_id: edited?.category_settings?.browser_node_id,
                    primary_category: edited?.category_settings?.primary_category,
                    secondary_category: edited?.category_settings?.sub_category,
                    category_fullpath: edited?.category_settings?.displayPath?.join?.(" > ")
                  }
                };
              } else if (!!profile_info?.category_settings?.product_type) { // If profile has product_type
                categ_product_type_data = {
                  product_type: profile_info?.category_settings?.product_type,
                  init_product_type: profile_info?.category_settings?.product_type,
                  getData: profile_info?.attributes_mapping?.data?.jsonFeed,
                  currentData: profile_info?.attributes_mapping?.data?.jsonFeed,
                  from: 'profile',
                  suggested_product_types: [],
                  loadingSuggestions: false,
                  selection_type: "default",
                  init_selection_type: "default",
                  category_data: {
                    browse_node_id: profile_info?.category_settings?.browser_node_id,
                    primary_category: profile_info?.category_settings?.primary_category,
                    secondary_category: profile_info?.category_settings?.sub_category,
                    category_fullpath: profile_info?.category_settings?.displayPath?.join?.(" > ")
                  }
                };
              } else {
                categ_product_type_data = {
                  product_type: '',
                  init_product_type: '',
                  suggested_product_types: [],
                  loadingSuggestions: false,
                  selection_type: "custom",
                  init_selection_type: "custom",
                  category_data: {}
                }
              }
            }
          }

          //Listing Type
          if (componentState.initialProductData['status'] === AVAILABLE_FOR_OFFER) { // tab === offer if initial status is offer
            modified_product = { ...modified_product, listing_type: 'offer_listing' };
          } else {
            const pick_edited = componentState?.product_type?.variantEdit ? parent_details?.edited : edited;
            const pick_profile = componentState?.product_type?.variantEdit ? parent_details?.profile_info ?? profile_info : profile_info;
            if (pick_edited && pick_edited?.['category_settings']) {
              modified_product = {
                ...modified_product,
                listing_type: pick_edited?.['category_settings']?.['product_type'] === 'PRODUCT' ? 'offer_listing' : 'new_listing',
              };
            } else if (pick_profile && pick_profile?.['category_settings']) {
              modified_product = {
                ...modified_product,
                listing_type: pick_profile?.['category_settings']?.['product_type'] === 'PRODUCT' ? 'offer_listing' : 'new_listing',
              };
            } else {
              //tab =new
              modified_product = {
                ...modified_product,
                listing_type: 'new_listing',
              };
            }
          }

          if (parent_details) {
            modified_product = {
              ...modified_product,
              ...setContextKeys('parent_details', parent_details ?? []),
            };
          }
          if (element.hasOwnProperty('variant_attributes')) {
            componentState.initialProductData['hasVariants'] =
              element['variant_attributes'].length > 0;
          }
          if (element.hasOwnProperty('visibility') && element.hasOwnProperty('type')) {
            componentState.initialProductData['hasVariants'] = element.visibility == "Catalog and Search" && element.type == "variation"
          }
          // ---------------------------------------BARCODE EXEMPTION---------------------------
          if (!componentState['product_type']['variantEdit']) {
            if (edited && edited?.category_settings?.hasOwnProperty('barcode_exemption')) { //Highest priority of barcode_exemption will be given to the edited one.
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys(
                  'barcode_exemption',
                  edited?.['category_settings']?.['barcode_exemption']
                ),
              };
              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys(
                  'barcode_exemption',
                  'custom'
                ),
              };
            } else if (profile_info) {
              if (profile_info?.category_settings?.hasOwnProperty('barcode_exemption')) {
                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys('barcode_exemption', profile_info?.['category_settings']?.['barcode_exemption'])
                }
                modified_product['selection_type'] = {
                  ...modified_product['selection_type'],
                  ...setContextKeys(
                    'barcode_exemption',
                    'custom'
                  ),
                };
              }
            } else {
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys('barcode_exemption', false),
              };
              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys(
                  'barcode_exemption',
                  'custom'
                ),
              };
            }
          } else { // Pick barcode exemption for variant edit
            if (parent_details?.edited && parent_details?.edited?.category_settings?.hasOwnProperty('barcode_exemption')) { //Highest priority of barcode_exemption will be given to the edited one.
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys(
                  'barcode_exemption',
                  parent_details?.edited?.['category_settings']?.['barcode_exemption']
                ),
              };
              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys(
                  'barcode_exemption',
                  'custom'
                ),
              };
            } else if (parent_details?.profile_info ?? profile_info) {
              if ((parent_details?.profile_info ?? profile_info)?.category_settings?.hasOwnProperty('barcode_exemption')) {
                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys('barcode_exemption', (parent_details?.profile_info ?? profile_info)?.['category_settings']?.['barcode_exemption'])
                }
                modified_product['selection_type'] = {
                  ...modified_product['selection_type'],
                  ...setContextKeys(
                    'barcode_exemption',
                    'custom'
                  ),
                };
              }
            } else {
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys('barcode_exemption', false),
              };
              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys(
                  'barcode_exemption',
                  'custom'
                ),
              };
            }
          }
          // ------------------ Title -----------------------------
          if (edited && edited.hasOwnProperty('title')) {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('title', edited?.title),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('title', 'custom'),
            };
          } else {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('title', title),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('title', 'default'),
            };
          }
          // ------------------ SKU -----------------------------
          if (edited && edited.hasOwnProperty('sku')) {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('sku', edited?.sku),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('sku', 'custom'),
            };
          } else {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('sku', sku ?? source_product_id),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys(
                'sku', componentState?.product_type.variantEdit ? 'default' : (type === 'simple' ? 'default' : 'custom')
              ),
            };
          }
          // ------------------ Description -----------------------------
          if (edited && edited.hasOwnProperty('description')) {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys(
                'description',
                edited?.description
              ),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('description', 'custom')
            };
          } else {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('description', description),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('description', 'default'),
            };
          }

          // ------------------ Image code -----------------------------
          if (
            edited &&
            edited.hasOwnProperty('main_image')
          ) {
            let allImages: any = [edited.main_image, ...(edited.additional_images ?? additional_images ?? [])];
            allImages.uniqueArray();
            let currentShopifyImages: any = allImages.filter((a: any) => a).filter((img: any) => img.includes("cdn.shopify.com")) ?? [];
            let currentMyfolderImages: any = allImages.filter((a: any) => a).filter((img: any) => img.includes("amazon-product-image-upload")) ?? [];
            let currentOptimizedImages: any = allImages.filter((a: any) => a).filter((img: any) => img.includes("smartlister-image-upload")) ?? [];

            let tempImageHolder: any = [];
            tempImageHolder.push(
              edited.main_image,
              ...(edited?.additional_images ?? additional_images ?? [])
            );
            tempImageHolder.uniqueArray();
            if (tempImageHolder.length > 9) {
              tempImageHolder = tempImageHolder.slice(0, 9)
            }
            modified_product = {
              ...modified_product,
              shopify_images: [...currentShopifyImages].filter(
                (ele, ind) =>
                  ele != null && ele != undefined && ele != ''
              ),
              myfolder_images: [...currentMyfolderImages].filter(
                (ele, ind) =>
                  ele != null && ele != undefined && ele != ''
              ),
              optimized_images: [...currentOptimizedImages].filter(
                (ele, ind) =>
                  ele != null && ele != undefined && ele != ''
              ),
              data: {
                ...modified_product['data'],
                ...setContextKeys(
                  'main_image',
                  edited.main_image
                ),
                ...setContextKeys(
                  'additional_images',
                  edited?.additional_images ?? additional_images ?? []
                ),
              },
              selected_images: [
                ...tempImageHolder,
                ...populateSelectedImages(
                  '',
                  9 - tempImageHolder.length
                ),
              ],
              selectedImageTab: 0
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('image_selection', 'custom'),
            };
          } else {
            let allImages: any = [main_image, ...(additional_images ?? [])];
            let currentShopifyImages: any = allImages.filter((a: any) => a).filter((img: any) => img.includes("cdn.shopify.com")) ?? [];
            let currentMyfolderImages: any = allImages.filter((a: any) => a).filter((img: any) => img.includes("amazon-product-image-upload")) ?? [];
            let currentOptimizedImages: any = allImages.filter((a: any) => a).filter((img: any) => img.includes("smartlister-image-upload")) ?? [];
            currentShopifyImages.uniqueArray();
            currentMyfolderImages.uniqueArray();
            currentOptimizedImages.uniqueArray();

            let selectedImages: any = [main_image, ...(additional_images ?? [])];
            selectedImages.uniqueArray();
            if (selectedImages.length > 9) {
              selectedImages = selectedImages.slice(0, 9);
            }
            else {
              selectedImages = [...selectedImages,
              ...populateSelectedImages(
                '',
                9 - selectedImages.length
              )]
            }
            modified_product = {
              ...modified_product,
              shopify_images: [...currentShopifyImages].filter(
                (ele, ind) =>
                  ele != null && ele != undefined && ele != ''
              ),
              myfolder_images: [...currentMyfolderImages].filter(
                (ele, ind) =>
                  ele != null && ele != undefined && ele != ''
              ),
              optimized_images: [...currentOptimizedImages].filter(
                (ele, ind) =>
                  ele != null && ele != undefined && ele != ''
              ),
              data: {
                ...modified_product['data'],
                ...setContextKeys('main_image', main_image),
                ...setContextKeys(
                  'additional_images',
                  additional_images ?? []
                ),
              },
              selectedImageTab: 0,
              selected_images: [...selectedImages],
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('image_selection', 'default'),
            };
          }

          // ------------------ Inventory Fulfillment Latency(Handling Time)-----------------------------
          if (
            edited &&
            edited.hasOwnProperty('inventory_fulfillment_latency')
          ) {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys(
                'inventory_fulfillment_latency',
                edited?.inventory_fulfillment_latency
              ),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys(
                'inventory_fulfillment_latency',
                'custom'
              ),
            };
          } else if (
            profile_info &&
            Object.keys(profile_info).length > 0
          ) {
            let tempHandlingTime: any = [];
            Object.keys(profile_info?.['data']).filter((ele) => {
              if (
                profile_info?.['data'][ele]?.['data_type'] ===
                'inventory_settings'
              )
                tempHandlingTime =
                  profile_info?.['data'][ele]?.['data']?.[
                  'inventory_fulfillment_latency'
                  ] ?? '2';
            });
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys(
                'inventory_fulfillment_latency',
                tempHandlingTime
              ),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys(
                'inventory_fulfillment_latency',
                'default'
              ),
            };
          } else {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys(
                'inventory_fulfillment_latency',
                '2'
              ),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys(
                'inventory_fulfillment_latency',
                'default'
              ),
            };
          }

          //Fulfillment type
          if (edited && edited.hasOwnProperty('fulfillment_type')) {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys(
                'fulfillment_type',
                edited?.fulfillment_type ?? 'FBM'
              ),
            };
          }
          else if (componentState?.product_type?.variantEdit && parent_details && Object?.keys(parent_details)?.length > 0 && parent_details?.hasOwnProperty("edited")) { // parent_details
            if (parent_details?.edited?.hasOwnProperty("fulfillment_type")) {
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys(
                  'fulfillment_type',
                  parent_details?.edited?.fulfillment_type ?? 'FBM'
                ),
              };
            }
            else {
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys(
                  'fulfillment_type',
                  'FBM'
                ),
              };
            }
          }
          else if (profile_info && Object.keys(profile_info).length > 0) {
            let tempFulfillmentType: any = getFulfillmentType(profile_info) ?? "FBM";
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys(
                'fulfillment_type',
                tempFulfillmentType
              ),
            };
          } else {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys(
                'fulfillment_type',
                'FBM'
              ),
            };
          }

          //Price code
          let currency_settings = extractCurrencySettings(defaultSettings);
          if (edited && (edited.hasOwnProperty('price') || edited.hasOwnProperty("price_rules"))) {
            let tempPriceModifier: any = JSON.parse(JSON.stringify(defaultPrice));
            if (edited?.price_rules && Object?.keys(edited?.price_rules)?.length > 0) {
              tempPriceModifier = { ...tempPriceModifier, ...(edited?.price_rules ?? {}), shopify_price: price }
            }
            else {
              tempPriceModifier = {
                attribute: "custom",
                value: edited?.price + '',
                price_roundoff_value: "",
                shopify_price: price
              }
            }
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('price', tempPriceModifier),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('price', 'custom'),
            };

            //if swicth custom to default then it is not filling raw data and hence price breakup is not shown
            // price from parent details(if variant) -> template -> global settings
            let rawPriceSettings: any = {};

            if (componentState?.product_type?.variantEdit && parent_details && Object?.keys(parent_details)?.length > 0 && parent_details?.hasOwnProperty("edited") && parent_details?.edited?.hasOwnProperty("price_rules") && Object.keys(parent_details?.edited?.price_rules)?.length > 0) {
              // if (parent_details?.edited?.hasOwnProperty("price_rules") && Object.keys(parent_details?.edited?.price_rules)?.length > 0) { // parent details
              rawPriceSettings = {
                shopify_price: price,
                standard_price: parent_details?.edited?.price_rules ?? {},
                currency_settings,
                from: "Variant's Parent"
              };
              // }
              // else {
              //     rawPriceSettings = {
              //         shopify_price: price,
              //         standard_price: JSON.parse(JSON.stringify(defaultPrice)),
              //         currency_settings,
              //         from: "parent"
              //     };
              // }
            }
            else if (profile_info && profile_info?.data) { // template settings
              let price_settings: any = profile_info?.data.filter(
                (elem: any) =>
                  elem?.['data']?.['data_type'] ===
                  'price_settings'
              )?.[0]?.data;

              if (Object.keys(price_settings)?.length > 0) {
                if (price_settings?.settings_enabled) {
                  if (price_settings?.['standard_price'] && Object?.keys(price_settings?.['standard_price'] ?? {})?.length > 0) {
                    rawPriceSettings = {
                      shopify_price: price,
                      standard_price: price_settings?.['standard_price'] ?? {},
                      currency_settings
                    }
                  }
                  else {
                    rawPriceSettings = {
                      shopify_price: price,
                      standard_price: {
                        attribute: "default",
                        value: "",
                        price_roundoff_value: ""
                      },
                      currency_settings
                    }
                  }
                }
                else { //if profile is applied but price settings are turned off, show banner that you have disabled price settings in the applied profile/template
                  rawPriceSettings = {
                    shopify_price: price,
                    currency_settings
                  }
                }
                rawPriceSettings = { ...rawPriceSettings, from: "Template" };
              }
            }
            else {// global settings
              let defaultSettings: any = defatulProfileSettings.filter((setting: any) => setting?.group_code == "price")?.[0]?.value ?? {};

              if (Object.keys(defaultSettings)?.length > 0) {
                if (defaultSettings?.settings_enabled) {
                  if (defaultSettings?.['standard_price'] && Object?.keys(defaultSettings?.['standard_price'] ?? {})?.length > 0) {
                    rawPriceSettings = {
                      shopify_price: price,
                      standard_price: defaultSettings?.['standard_price'] ?? {},
                      currency_settings
                    }
                  }
                  else {
                    rawPriceSettings = {
                      shopify_price: price,
                      standard_price: {
                        attribute: "default",
                        value: "",
                        price_roundoff_value: ""
                      },
                      currency_settings
                    }
                  }
                }
                else { //if profile is applied but price settings are turned off, show banner that you have disabled price settings in the applied profile/template
                  rawPriceSettings = {
                    shopify_price: price,
                    currency_settings
                  }
                }
                rawPriceSettings = { ...rawPriceSettings, from: "Global Settings" };
              }
            }
            modified_product['raw_data'] = {
              ...modified_product['raw_data'],
              rawPriceSettings,
            };
          }
          else if (componentState?.product_type?.variantEdit && parent_details && Object?.keys(parent_details)?.length > 0 && parent_details?.hasOwnProperty("edited") && parent_details?.edited?.hasOwnProperty("price_rules") && Object.keys(parent_details?.edited?.price_rules)?.length > 0) { // parent details
            let rawPriceSettings: any = {};
            // if (parent_details?.edited?.hasOwnProperty("price_rules") && Object.keys(parent_details?.edited?.price_rules)?.length > 0) { // parent details
            rawPriceSettings = {
              shopify_price: price,
              standard_price: parent_details?.edited?.price_rules ?? {},
              currency_settings,
              from: "Variant's Parent"
            }
            modified_product['raw_data'] = {
              ...modified_product['raw_data'],
              rawPriceSettings,
            };

            let tempPriceModifier = {
              ...JSON.parse(JSON.stringify(defaultPrice)),
              ...parent_details?.edited?.price_rules,
              shopify_price: price
            }

            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('price', tempPriceModifier),
            };

            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('price', 'default'),
            };
            // }
            // else {

            //     rawPriceSettings = {
            //         shopify_price: price,
            //         standard_price: JSON.parse(JSON.stringify(defaultPrice)),
            //         currency_settings,
            //         from: "parent"
            //     }
            //     modified_product['raw_data'] = {
            //         ...modified_product['raw_data'],
            //         rawPriceSettings,
            //     };

            //     let tempPriceModifier = {
            //         ...JSON.parse(JSON.stringify(defaultPrice)),
            //         shopify_price: price
            //     }

            //     modified_product['data'] = {
            //         ...modified_product['data'],
            //         ...setContextKeys('price', tempPriceModifier),
            //     };

            //     modified_product['selection_type'] = {
            //         ...modified_product['selection_type'],
            //         ...setContextKeys('price', 'default'),
            //     };
            // }
          }
          else if (profile_info && profile_info?.data) {
            let price_settings: any = profile_info?.data.filter(
              (elem: any) =>
                elem?.['data']?.['data_type'] ===
                'price_settings'
            )?.[0]?.data;
            let rawPriceSettings = {};

            if (Object.keys(price_settings)?.length > 0) {
              let tempPriceModifier: any = JSON.parse(JSON.stringify(defaultPrice));
              if (price_settings?.settings_enabled) {
                if (price_settings?.['standard_price'] && Object?.keys(price_settings?.['standard_price'] ?? {})?.length > 0) {
                  rawPriceSettings = {
                    shopify_price: price,
                    standard_price: price_settings?.['standard_price'] ?? {},
                    currency_settings
                  }

                  tempPriceModifier = {
                    ...tempPriceModifier,
                    ...(price_settings?.['standard_price'] ?? {}),
                    shopify_price: price
                  }
                }
                else {
                  rawPriceSettings = {
                    shopify_price: price,
                    standard_price: {
                      attribute: "default",
                      value: "",
                      price_roundoff_value: ""
                    },
                    currency_settings
                  }

                  tempPriceModifier = {
                    ...tempPriceModifier,
                    ...{
                      attribute: "default",
                      value: "",
                      price_roundoff_value: ""
                    },
                    shopify_price: price
                  }
                }
              }
              else { //if profile is applied but price settings are turned off, show banner that you have disabled price settings in the applied profile/template
                rawPriceSettings = { shopify_price: price, currency_settings, };
                tempPriceModifier = { ...tempPriceModifier, shopify_price: price }
              }

              rawPriceSettings = {
                ...rawPriceSettings,
                from: "Template"
              }

              modified_product['raw_data'] = {
                ...modified_product['raw_data'],
                rawPriceSettings,
              };

              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys('price', tempPriceModifier),
              };

              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys('price', 'default'),
              };
            }
          }
          else {
            let defaultPriceSettings: any = defatulProfileSettings?.[0]?.['value'];
            if (Object.keys(defaultPriceSettings)?.length > 0) {
              let tempPriceModifier: any = JSON.parse(JSON.stringify(defaultPrice))
              let rawPriceSettings = {};

              if (defaultPriceSettings?.settings_enabled) {
                if (defaultPriceSettings?.['standard_price'] && Object?.keys(defaultPriceSettings?.['standard_price'])?.length > 0) {
                  rawPriceSettings = {
                    shopify_price: price,
                    standard_price: defaultPriceSettings?.['standard_price'] ?? {},
                    currency_settings
                  }

                  tempPriceModifier = {
                    ...tempPriceModifier,
                    ...(defaultPriceSettings?.['standard_price'] ?? {}),
                    shopify_price: price
                  }
                }
                else {
                  rawPriceSettings = {
                    shopify_price: price,
                    standard_price: {
                      attribute: "default",
                      value: "",
                      price_roundoff_value: ""
                    },
                    currency_settings
                  }

                  tempPriceModifier = {
                    ...tempPriceModifier,
                    ...{
                      attribute: "default",
                      value: "",
                      price_roundoff_value: ""
                    },
                    shopify_price: price
                  }
                }
              }
              else { //if global settings are applied but price settings are turned off, show banner that you have disabled price settings in the applied global settings
                rawPriceSettings = { shopify_price: price, currency_settings };
                tempPriceModifier = { ...tempPriceModifier, shopify_price: price }
              }

              rawPriceSettings = {
                ...rawPriceSettings,
                from: "Global Settings"
              }

              modified_product['raw_data'] = {
                ...modified_product['raw_data'],
                rawPriceSettings
              };

              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys('price', tempPriceModifier),
              };

              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys('price', 'default'),
              };
            }
          }
          modified_product['raw_data'] = {
            ...modified_product['raw_data'],
            defaultSettings: defaultSettings,
          };

          //Inventory code
          if (edited && (edited.hasOwnProperty('quantity') || edited.hasOwnProperty("quantity_rules"))) {
            let tempQuantityModifier: any = JSON.parse(JSON.stringify(defaultInventory));
            if (edited?.quantity_rules && Object?.keys(edited?.quantity_rules)?.length > 0) {
              tempQuantityModifier = { ...tempQuantityModifier, ...(edited?.quantity_rules ?? {}), shopify_quantity: quantity }
            }
            else {
              tempQuantityModifier = {
                "continue_selling": {
                  "enabled": true,
                  "value": "999"
                },
                "effective_inventory": {
                  "enabled": false,
                  "type": "none",
                  "value": '',
                },
                "attribute": "custom",
                "value": edited?.quantity,
                shopify_quantity: quantity
              }
            }
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('quantity', tempQuantityModifier),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('quantity', 'custom'),
            };

            //if swicth custom to default then it is not filling raw data and hence price breakup is not shown
            // price from parent details(if variant) -> template -> global settings
            let rawQuantitySettings: any = {};

            if (componentState?.product_type?.variantEdit && parent_details && Object?.keys(parent_details)?.length > 0 && parent_details?.hasOwnProperty("edited") && parent_details?.edited?.hasOwnProperty("quantity_rules") && Object.keys(parent_details?.edited?.quantity_rules)?.length > 0) {
              rawQuantitySettings = {
                shopify_quantity: quantity,
                quantity: parent_details?.edited?.quantity_rules ?? {},
                from: "Variant's Parent",
                enabled: true
              };
            }
            else if (profile_info && profile_info?.data) {// template settings
              let { data: profile_data } = profile_info;
              let tempInventorySettings: any =
                profile_data.filter(
                  (elem: any) =>
                    elem?.['data_type'] ===
                    'inventory_settings'
                );
              tempInventorySettings = tempInventorySettings?.[0].data;
              let tempInventory: any = JSON.parse(JSON.stringify(defaultInventory));
              if (tempInventorySettings && Object?.keys?.(tempInventorySettings)?.length > 0 && tempInventorySettings?.inventory_settings) {
                tempInventory = {
                  ...tempInventory,
                  ...tempInventorySettings
                }
                rawQuantitySettings = {
                  shopify_quantity: quantity,
                  quantity: tempInventory ?? {},
                  from: "Template",
                  enabled: true
                };
              }
              else {
                rawQuantitySettings = {
                  shopify_quantity: quantity,
                  quantity: tempInventory ?? {},
                  from: "Template",
                  enabled: false
                };
              }
            }
            else {// global settings
              let inventory_settings: any = defaultSettings?.filter((elem: any) => elem?.['key'] === 'inventory')?.[0]?.['value'];
              let tempInventory: any = JSON.parse(JSON.stringify(defaultInventory));
              if (inventory_settings && hasLength(inventory_settings)) {
                if (inventory_settings?.inventory_settings) {
                  tempInventory = {
                    ...tempInventory,
                    ...inventory_settings
                  }
                  rawQuantitySettings = {
                    shopify_quantity: quantity,
                    quantity: tempInventory ?? {},
                    from: "Global Settings",
                    enabled: true
                  };
                }
                else {
                  rawQuantitySettings = {
                    shopify_quantity: quantity,
                    quantity: tempInventory ?? {},
                    from: "Global Settings",
                    enabled: false
                  };
                }
              }
              else { //when user onboards first time we don't get inv obj from global so default settings should be shown with inv settings set to true
                rawQuantitySettings = {
                  shopify_quantity: quantity,
                  quantity: tempInventory ?? {},
                  from: "Global Settings",
                  enabled: true
                };
              }
            }
            modified_product['raw_data'] = {
              ...modified_product['raw_data'],
              rawQuantitySettings,
            };
          }
          else if (componentState?.product_type?.variantEdit && parent_details && Object?.keys(parent_details)?.length > 0 && parent_details?.hasOwnProperty("edited") && parent_details?.edited?.hasOwnProperty("quantity_rules") && Object.keys(parent_details?.edited?.quantity_rules)?.length > 0) { // parent details
            let rawQuantitySettings: any = {};
            rawQuantitySettings = {
              shopify_quantity: quantity,
              quantity: parent_details?.edited?.quantity_rules ?? {},
              from: "Variant's Parent",
              enabled: true
            }
            modified_product['raw_data'] = {
              ...modified_product['raw_data'],
              rawQuantitySettings,
            };

            let tempQuantityModifier = {
              ...JSON.parse(JSON.stringify(defaultInventory)),
              ...parent_details?.edited?.quantity_rules,
              shopify_quantity: quantity,
            }

            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('quantity', tempQuantityModifier),
            };

            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('quantity', 'default'),
            };
          }
          else if (profile_info && profile_info?.data) {
            let { data: profile_data } = profile_info;
            let tempInventorySettings: any = profile_data.filter((elem: any) => elem?.['data_type'] === 'inventory_settings');
            tempInventorySettings = tempInventorySettings?.[0].data;
            let rawQuantitySettings: any = {};
            if (tempInventorySettings && Object?.keys?.(tempInventorySettings)?.length > 0 && tempInventorySettings?.inventory_settings) {
              rawQuantitySettings = {
                shopify_quantity: quantity,
                quantity: { ...defaultInventory, ...(tempInventorySettings ?? {}) },
                from: "Template",
                enabled: true
              }
              modified_product['raw_data'] = {
                ...modified_product['raw_data'],
                rawQuantitySettings,
              };

              let tempQuantityModifier = {
                ...JSON.parse(JSON.stringify(defaultInventory)),
                ...tempInventorySettings,
                shopify_quantity: quantity,
              }

              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys('quantity', tempQuantityModifier),
              };

              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys('quantity', 'default'),
              };
            }
            else {
              rawQuantitySettings = {
                shopify_quantity: quantity,
                quantity: JSON.parse(JSON.stringify(defaultInventory)),
                from: "Template",
                enabled: false
              }
              modified_product['raw_data'] = {
                ...modified_product['raw_data'],
                rawQuantitySettings,
              };

              let tempQuantityModifier = {
                ...JSON.parse(JSON.stringify(defaultInventory)),
                shopify_quantity: quantity,
              }

              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys('quantity', tempQuantityModifier),
              };

              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys('quantity', 'default'),
              };
            }
          }
          else {
            let inventory_settings: any = defaultSettings?.filter((elem: any) => elem?.['key'] === 'inventory')?.[0]?.['value'];
            let rawQuantitySettings: any = {};
            if (inventory_settings && hasLength(inventory_settings)) {
              if (inventory_settings?.inventory_settings) {
                rawQuantitySettings = {
                  shopify_quantity: quantity,
                  quantity: { ...defaultInventory, ...(inventory_settings ?? {}) },
                  from: "Global Settings",
                  enabled: true
                }
                modified_product['raw_data'] = {
                  ...modified_product['raw_data'],
                  rawQuantitySettings,
                };

                let tempQuantityModifier = {
                  ...JSON.parse(JSON.stringify(defaultInventory)),
                  ...inventory_settings,
                  shopify_quantity: quantity,
                }

                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys('quantity', tempQuantityModifier),
                };

                modified_product['selection_type'] = {
                  ...modified_product['selection_type'],
                  ...setContextKeys('quantity', 'default'),
                };
              }
              else {
                rawQuantitySettings = {
                  shopify_quantity: quantity,
                  quantity: JSON.parse(JSON.stringify(defaultInventory)),
                  from: "Global Settings",
                  enabled: false
                }
                modified_product['raw_data'] = {
                  ...modified_product['raw_data'],
                  rawQuantitySettings,
                };

                let tempQuantityModifier = {
                  ...JSON.parse(JSON.stringify(defaultInventory)),
                  shopify_quantity: quantity,
                }

                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys('quantity', tempQuantityModifier),
                };

                modified_product['selection_type'] = {
                  ...modified_product['selection_type'],
                  ...setContextKeys('quantity', 'default'),
                };
              }
            }
            else { //when user onboards first time we don't get inv obj from global so default settings should be shown with inv settings set to true
              rawQuantitySettings = {
                shopify_quantity: quantity,
                quantity: JSON.parse(JSON.stringify(defaultInventory)),
                from: "Global Settings",
                enabled: true
              }
              modified_product['raw_data'] = {
                ...modified_product['raw_data'],
                rawQuantitySettings,
              };

              let tempQuantityModifier = {
                ...JSON.parse(JSON.stringify(defaultInventory)),
                shopify_quantity: quantity,
              }

              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys('quantity', tempQuantityModifier),
              };

              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys('quantity', 'default'),
              };
            }
          }

          //Business Price
          if (edited && ((edited.hasOwnProperty('business_price') && Object.keys(edited?.business_price)?.length > 0) || edited?.business_price_enabled)) { // edited business price object
            let businessErrors = JSON.parse(JSON.stringify(businessPriceErrors));
            let tempBusinessPrice: any = { ...JSON.parse(JSON.stringify(defaultBusinessPrice)), ...edited?.business_price };
            if (edited?.business_price?.quantity_type && edited?.business_price?.quantity_type != "") {
              setShowBusinessPrice(true);
              if (edited?.business_price?.quantity_type == "fixed") {
                tempBusinessPrice = { ...tempBusinessPrice, fixed: edited?.business_price?.quantity_discount }
                businessErrors['fixed'] = Array.from({ length: edited?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));
              }
              else {
                tempBusinessPrice = { ...tempBusinessPrice, percent: edited?.business_price?.quantity_discount }
                businessErrors['percent'] = Array.from({ length: edited?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));
              }
            }
            businessErrors['fixed'] = Array.from({ length: edited?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));
            setBusinessPriceErrors(JSON.parse(JSON.stringify(businessErrors)));
            delete tempBusinessPrice['quantity_discount'];

            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys("business_price_enabled", edited?.business_price_enabled)
            }

            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('business_price', tempBusinessPrice),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys(
                'business_price',
                'custom'
              ),
            };

            // business price from parent details(if variant) -> template -> global settings
            let rawBusinessPriceSettings: any = {};
            let rawShowBusinessPrice = false;
            let rawBusinessPriceEnabled = false;
            let from: string = ""

            if (componentState?.product_type?.variantEdit && parent_details && Object?.keys(parent_details)?.length > 0 && parent_details?.hasOwnProperty("edited")) {
              if (parent_details?.edited?.hasOwnProperty("business_price") && Object.keys(parent_details?.edited?.business_price)?.length > 0) { // parent details
                rawBusinessPriceSettings = { ...JSON.parse(JSON.stringify(defaultBusinessPrice)), ...parent_details?.edited?.business_price }
                if (parent_details?.edited?.business_price?.quantity_type && parent_details?.edited?.business_price?.quantity_type != "") {
                  rawShowBusinessPrice = true;
                  if (parent_details?.edited?.business_price?.quantity_type == "fixed") {
                    rawBusinessPriceSettings = { ...rawBusinessPriceSettings, fixed: parent_details?.edited?.business_price?.quantity_discount }
                  }
                  else {
                    rawBusinessPriceSettings = { ...rawBusinessPriceSettings, percent: parent_details?.edited?.business_price?.quantity_discount }
                  }
                }
                delete rawBusinessPriceSettings['quantity_discount'];
                rawBusinessPriceEnabled = parent_details?.edited?.business_price_enabled ?? false;
                from = "Variant's Parent";
              }
              else { //if parent business price settings are applied but business price settings are turned off, show banner that you have disabled business price settings in the applied parent business price settings
                rawBusinessPriceSettings = {};
                rawBusinessPriceEnabled = false;
                rawShowBusinessPrice = false;
              }
            }
            else if (profile_info && profile_info?.data) { // template settings
              let price_settings: any = profile_info?.data.filter(
                (elem: any) =>
                  elem?.['data']?.['data_type'] ===
                  'price_settings'
              )?.[0]?.data;
              if (price_settings?.settings_enabled && price_settings?.settings_selected?.business_price) {
                rawBusinessPriceSettings = { ...JSON.parse(JSON.stringify(defaultBusinessPrice)), ...price_settings?.business_price }
                if (price_settings?.business_price?.quantity_type && price_settings?.business_price?.quantity_type != "") {
                  rawShowBusinessPrice = true;
                  if (price_settings?.business_price?.quantity_type == "fixed") {
                    rawBusinessPriceSettings = { ...rawBusinessPriceSettings, fixed: price_settings?.business_price?.quantity_discount }
                  }
                  else {
                    rawBusinessPriceSettings = { ...rawBusinessPriceSettings, percent: price_settings?.business_price?.quantity_discount }
                  }
                }
                delete rawBusinessPriceSettings['quantity_discount'];
                rawBusinessPriceEnabled = price_settings?.settings_selected?.business_price ?? false;
                from = "Template"
              }
              else { //if profile is applied but business price settings are turned off, show banner that you have disabled business price settings in the applied profile/template
                rawBusinessPriceSettings = {};
                rawBusinessPriceEnabled = false;
                rawShowBusinessPrice = false;
              }
            }
            else {// global settings
              let defaultSettings: any = defatulProfileSettings.filter((setting: any) => setting?.group_code == "price")?.[0]?.value ?? {};
              if (defaultSettings?.settings_enabled && defaultSettings?.settings_selected?.business_price) {
                rawBusinessPriceSettings = { ...JSON.parse(JSON.stringify(defaultBusinessPrice)), ...defaultSettings?.business_price }
                if (defaultSettings?.business_price?.quantity_type && defaultSettings?.business_price?.quantity_type != "") {
                  rawShowBusinessPrice = true;
                  if (defaultSettings?.business_price?.quantity_type == "fixed") {
                    rawBusinessPriceSettings = { ...rawBusinessPriceSettings, fixed: defaultSettings?.business_price?.quantity_discount }
                  }
                  else {
                    rawBusinessPriceSettings = { ...rawBusinessPriceSettings, percent: defaultSettings?.business_price?.quantity_discount }
                  }
                }
                delete rawBusinessPriceSettings['quantity_discount'];
                rawBusinessPriceEnabled = defaultSettings?.settings_selected?.business_price ?? false;
                from = "Global Settings"
              }
              else { //if global settings are applied but business price settings are turned off, show banner that you have disabled business price settings in the applied global settings
                rawBusinessPriceSettings = {};
                rawBusinessPriceEnabled = false;
                rawShowBusinessPrice = false;
              }
            }
            modified_product['raw_data'] = {
              ...modified_product['raw_data'],
              rawBusinessPriceSettings,
              rawShowBusinessPrice,
              rawBusinessPriceEnabled,
              from
            };
          }
          else if (componentState?.product_type?.variantEdit && parent_details && Object?.keys(parent_details)?.length > 0 && parent_details?.hasOwnProperty("edited") && parent_details?.edited?.hasOwnProperty("business_price") && Object.keys(parent_details?.edited?.business_price)?.length > 0) { // parent details
            let tempBusinessPrice: any = JSON.parse(JSON.stringify(defaultBusinessPrice));
            let rawShowBusinessPrice = false;
            let rawBusinessPriceEnabled = false;
            let businessErrors = JSON.parse(JSON.stringify(businessPriceErrors));
            if (parent_details?.edited?.business_price_enabled) {
              rawBusinessPriceEnabled = true;
              tempBusinessPrice = { ...JSON.parse(JSON.stringify(tempBusinessPrice)), ...(parent_details?.edited?.business_price ?? {}) };
              if (parent_details?.edited?.business_price?.quantity_type && parent_details?.edited?.business_price?.quantity_type != "") {
                rawShowBusinessPrice = true;
                setShowBusinessPrice(true);
                if (parent_details?.edited?.business_price?.quantity_type == "fixed") {
                  businessErrors['fixed'] = Array.from({ length: parent_details?.edited?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));
                  tempBusinessPrice = { ...tempBusinessPrice, fixed: parent_details?.edited?.business_price?.quantity_discount }
                }
                else {
                  businessErrors['percent'] = Array.from({ length: parent_details?.edited?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));

                  tempBusinessPrice = { ...tempBusinessPrice, percent: parent_details?.edited?.business_price?.quantity_discount }
                }
              }
              businessErrors['fixed'] = Array.from({ length: parent_details?.edited?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));
              setBusinessPriceErrors(JSON.parse(JSON.stringify(businessErrors)));
              delete tempBusinessPrice['quantity_discount'];

              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys("business_price_enabled", true)
              }

              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys('business_price', tempBusinessPrice),
              };

              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys(
                  'business_price',
                  'default'
                ),
              };

              modified_product['raw_data'] = {
                ...modified_product['raw_data'],
                rawBusinessPriceSettings: tempBusinessPrice,
                rawShowBusinessPrice,
                rawBusinessPriceEnabled,
                from: "Variant's Parent"
              };
            }
            else {
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys("business_price_enabled", false)
              }

              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys('business_price', tempBusinessPrice),
              };

              modified_product['selection_type'] = {
                ...modified_product['selection_type'],
                ...setContextKeys(
                  'business_price',
                  'default'
                ),
              };

              modified_product['raw_data'] = {
                ...modified_product['raw_data'],
                rawBusinessPriceSettings: {}, //empty since no business price settings from parent
                rawShowBusinessPrice,
                rawBusinessPriceEnabled,
                from: "Variant's Parent"
              };

            }
          }
          else if (profile_info && profile_info?.data) { //template
            let price_settings: any = profile_info?.data.filter(
              (elem: any) =>
                elem?.['data']?.['data_type'] ===
                'price_settings'
            )?.[0]?.data ?? {};
            let businessErrors = JSON.parse(JSON.stringify(businessPriceErrors));
            let tempBusinessPrice: any = JSON.parse(JSON.stringify(defaultBusinessPrice));
            let rawShowBusinessPrice = false;
            let rawBusinessPriceEnabled = false;
            if (Object?.keys(price_settings)?.length > 0) {
              if (price_settings?.settings_enabled && price_settings?.settings_selected?.business_price) {
                rawBusinessPriceEnabled = true;
                tempBusinessPrice = { ...JSON.parse(JSON.stringify(tempBusinessPrice)), ...(price_settings?.business_price ?? {}) };
                if (price_settings?.business_price?.quantity_type && price_settings?.business_price?.quantity_type != "") {
                  rawShowBusinessPrice = true;
                  setShowBusinessPrice(true);
                  if (price_settings?.business_price?.quantity_type == "fixed") {
                    businessErrors['fixed'] = Array.from({ length: price_settings?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));

                    tempBusinessPrice = { ...tempBusinessPrice, fixed: price_settings?.business_price?.quantity_discount }
                  }
                  else {
                    businessErrors['percent'] = Array.from({ length: price_settings?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));

                    tempBusinessPrice = { ...tempBusinessPrice, percent: price_settings?.business_price?.quantity_discount }
                  }
                }
                businessErrors['fixed'] = Array.from({ length: price_settings?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));
                setBusinessPriceErrors(JSON.parse(JSON.stringify(businessErrors)));

                delete tempBusinessPrice['quantity_discount'];

                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys("business_price_enabled", true)
                }

                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys('business_price', tempBusinessPrice),
                };

                modified_product['selection_type'] = {
                  ...modified_product['selection_type'],
                  ...setContextKeys(
                    'business_price',
                    'default'
                  ),
                };

                modified_product['raw_data'] = {
                  ...modified_product['raw_data'],
                  rawBusinessPriceSettings: tempBusinessPrice,
                  rawShowBusinessPrice,
                  rawBusinessPriceEnabled,
                  from: "Template"
                };
              }
              else {
                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys("business_price_enabled", false)
                }

                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys('business_price', tempBusinessPrice),
                };

                modified_product['selection_type'] = {
                  ...modified_product['selection_type'],
                  ...setContextKeys(
                    'business_price',
                    'default'
                  ),
                };

                modified_product['raw_data'] = {
                  ...modified_product['raw_data'],
                  rawBusinessPriceSettings: {}, //empty since no business price settings from template
                  rawShowBusinessPrice,
                  rawBusinessPriceEnabled,
                  from: "Template"
                };

              }
            }
          }
          else {
            let defaultPriceSettings: any = defatulProfileSettings?.filter((setting: any) => setting?.group_code == "price")?.[0]?.['value'];
            let tempPriceModifier: any = {};
            let businessErrors = JSON.parse(JSON.stringify(businessPriceErrors));
            let tempBusinessPrice: any = JSON.parse(JSON.stringify(defaultBusinessPrice));
            let rawShowBusinessPrice = false;
            let rawBusinessPriceEnabled = false;
            if (defaultPriceSettings && Object?.keys?.(defaultPriceSettings)?.length > 0) {
              if (defaultPriceSettings?.settings_enabled && defaultPriceSettings?.settings_selected?.business_price) {
                rawBusinessPriceEnabled = true;
                tempBusinessPrice = { ...JSON.parse(JSON.stringify(tempBusinessPrice)), ...(defaultPriceSettings?.business_price ?? {}) };
                if (defaultPriceSettings?.business_price?.quantity_type && defaultPriceSettings?.business_price?.quantity_type != "") {
                  rawShowBusinessPrice = true;
                  setShowBusinessPrice(true);
                  if (defaultPriceSettings?.business_price?.quantity_type == "fixed") {
                    businessErrors['fixed'] = Array.from({ length: defaultPriceSettings?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));
                    tempBusinessPrice = { ...tempBusinessPrice, fixed: defaultPriceSettings?.business_price?.quantity_discount }
                  }
                  else {
                    businessErrors['percent'] = Array.from({ length: defaultPriceSettings?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));
                    tempBusinessPrice = { ...tempBusinessPrice, percent: defaultPriceSettings?.business_price?.quantity_discount }
                  }
                }
                businessErrors['fixed'] = Array.from({ length: defaultPriceSettings?.business_price?.quantity_discount?.length ?? 1 }, () => ({ quantity: false, price: false, touched: { quantity: true, price: true } }));
                setBusinessPriceErrors(JSON.parse(JSON.stringify(businessErrors)));
                delete tempBusinessPrice['quantity_discount'];

                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys("business_price_enabled", true)
                }

                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys('business_price', tempBusinessPrice),
                };

                modified_product['selection_type'] = {
                  ...modified_product['selection_type'],
                  ...setContextKeys(
                    'business_price',
                    'default'
                  ),
                };

                modified_product['raw_data'] = {
                  ...modified_product['raw_data'],
                  rawBusinessPriceSettings: tempBusinessPrice,
                  rawShowBusinessPrice,
                  rawBusinessPriceEnabled,
                  from: "Global Settings"
                };
              }
              else {
                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys("business_price_enabled", false)
                }

                modified_product['data'] = {
                  ...modified_product['data'],
                  ...setContextKeys('business_price', tempBusinessPrice),
                };

                modified_product['selection_type'] = {
                  ...modified_product['selection_type'],
                  ...setContextKeys(
                    'business_price',
                    'default'
                  ),
                };

                modified_product['raw_data'] = {
                  ...modified_product['raw_data'],
                  rawBusinessPriceSettings: {}, //empty since no business price settings from template
                  rawShowBusinessPrice,
                  rawBusinessPriceEnabled,
                  from: "Global Settings"
                };
              }
            }
          }

          if (componentState?.product_type.variantEdit || !componentState.initialProductData['hasVariants']) {
            // Online selling
            if (edited && edited.hasOwnProperty('onlineSelling')) {
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys(
                  'onlineSelling',
                  edited.onlineSelling
                )
              }
            } else {
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys(
                  'onlineSelling',
                  true
                )
              }
            }

            //Local selling
            if (edited && edited.hasOwnProperty('localSelling')) {
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys(
                  'localSelling',
                  edited.localSelling
                )
              }

              if (edited.hasOwnProperty('localsellingStoreData') && edited?.localsellingStoreData?.length > 0) {
                modified_product = {
                  ...modified_product,
                  localsellingStoreData: getLocalsellingWarehouseData(localsellingStore, edited?.localsellingStoreData, componentState)
                }
              } else {
                modified_product = {
                  ...modified_product,
                  localsellingStoreData: getLocalsellingWarehouseData(localsellingStore, [], componentState)
                }
              }
            } else {
              modified_product['data'] = {
                ...modified_product['data'],
                ...setContextKeys(
                  'localSelling',
                  false
                )
              }
              modified_product = {
                ...modified_product,
                localsellingStoreData: getLocalsellingWarehouseData(localsellingStore, [], componentState)
              }
            }

            if (defaultSettings && defaultSettings?.length > 0) {
              defaultSettings?.map((configData: any) => {
                if (configData?.key === 'order' && Object.keys(configData?.value)?.length > 0) {
                  modified_product = {
                    ...modified_product,
                    isSellerEnabledForLocalSelling: configData?.value?.local_selling_enabled && configData?.value?.isSellerEnabledForLocalSelling
                  }
                }
              })
            }
          }

          // Barcode
          if (edited && edited.hasOwnProperty('barcode')) {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('barcode', edited?.barcode),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('barcode', 'custom'),
            };
          } else {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('barcode', barcode ?? ''),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('barcode', 'default'),
            };
          }

          if (edited && edited.hasOwnProperty('barcode_type')) {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('barcode_type', edited?.barcode_type),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('barcode_type', 'custom'),
            };
          } else {
            modified_product['data'] = {
              ...modified_product['data'],
              ...setContextKeys('barcode_type', ''),
            };
            modified_product['selection_type'] = {
              ...modified_product['selection_type'],
              ...setContextKeys('barcode_type', 'default'),
            };
          }

          modified_product = {
            ...modified_product,
            default_values: getAndSetDefaultValues({
              element: element, props: props, fields: [{
                key: 'inventory_settings',
                value: 'inventory_fulfillment_latency'
              }], default_profile_settings: defatulProfileSettings
            }),
            marketplace: element.marketplace,
            container_id: element.container_id,
            parent_source_product_id: element.visibility == "Catalog and Search" ? element.source_product_id : "",
            shopify_data: { ...element },
          }

          setCategoryProductType((prev: CategoryProductTypeI) => ({ ...prev, ...categ_product_type_data }))

          getCategoryAttributes(categ_product_type_data, modified_product?.data?.barcode_exemption);
          const { success: allProductTypesSuccess, data: allProductTypes } = await getAllProductTypes();
          if (allProductTypesSuccess && allProductTypes?.length > 0) {
            setAllProductTypes(allProductTypes);
          }
          if (categ_product_type_data?.init_selection_type === "custom" && modified_product?.listing_type !== AVAILABLE_FOR_OFFER && !componentState?.product_type.variantEdit) {
            getProductTypeSuggestions(modified_product?.data?.title, modified_product?.parent_source_product_id, categ_product_type_data.product_type);
          }
        }
        modified_product = {
          ...modified_product,
          localsellingActiveStore: [...localsellingStore],
          disablefields: {
            sku: isSectionVisible('sku', componentState, modified_product),
            barcode: isSectionVisible('barcode', componentState, modified_product)
          },
        };
      }
      if (defaultSettings && defaultSettings?.length > 0) {
        defaultSettings?.map((configData: any) => {
          if (configData?.key === 'tour' && Object.keys(configData?.value)?.length > 0) {
            modified_product = {
              ...modified_product,
              start_tour: configData?.value?.listing_tour_1_visited && !configData?.value?.listing_tour_2_visited
            }
          }
        })
      }
    } else {
      props.error(t('Error, while trying to get product data!'));
    }
    ref.current = { ...modified_product };
    dispatch({
      type: 'updateAll',
      payload: {
        ...modified_product,
        renderComponent: true,
        initialComponentState: ref?.current,
      },
    });
    loaderHandler('fullPage', false);
    setComponentState({ ...componentState });
  }

  function setNestedValue(obj: any, path: string, value: any) {
    const keys = path.split('.');
    let current = obj;

    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];
      if (!current[key] || typeof current[key] !== 'object') {
        current[key] = {};
      }
      current = current[key];
    }

    current[keys[keys.length - 1]] = value;
  }

  async function saveProductData() {
    if (isPageLoading(componentState)) {
      props.error(t('Page is loading, kindly wait...'));
    }
    else {
      setOtherAttributeErrors({});
      setIsOpen(false);
      setCurrentStep(-1);
      let modifiedData: any = [];
      let merge_data: any = [];

      modifiedData = {
        ...structuredProductData(state, componentState),
        target_marketplace: 'amazon',
        container_id: componentState.initialProductData.container_id,
        shop_id: props.redux.current.target._id,
        isAiEnable: "false",
        source_product_id: componentState.initialProductData.source_product_id,
        source_shop_id: props.redux.current.source._id ?? '',
        dont_validate_barcode: true,
        ...(state?.['listing_type'] && {
          parent_listing_type: state?.['listing_type'],
        }),
      };

      merge_data = [...merge_data, modifiedData];

      let feedData = JSONFeedRef.current && JSONFeedRef.current.saveJSONFeed(true);
      let { validatedKeys, hasError } = validator(merge_data, state, componentState, !!feedData);
      let { businessErrData, businessErr } = businessPriceValidator(state, JSON.parse(JSON.stringify(businessPriceErrors)), showBusinessPrice, props, t, componentState);
      let { priceErrData, priceErr } = priceValidator(state, priceErrors, props);
      let { quantityErrData, quantityErr } = quantityValidator(state, quantityErrors, props);
      let error_message = '';
      if (feedData && !hasError && feedData.hasError) {
        hasError = feedData.hasError;
        error_message = t('Attributes are missing or wrong, kindly check it before proceeding.');
      }
      if (!categoryProductType?.product_type?.length && !hasError) {
        hasError = true;
        error_message = componentState?.product_type?.variantEdit ? t('No Product type is selected in parent') : t('Product type is missing or wrong, kindly check it before proceeding.');
      }

      merge_data = merge_data.map((elem: any) => {
        if (!!JSONFeedAttributesData) { // new attributes UI is shown
          if (!componentState?.product_type?.variantEdit) { // edit is open for parent level seniority
            if (categoryProductType?.selection_type === "custom" || state?.listing_type === 'offer_listing') { // if custom product type is filled or product is of offer listing
              const is_offer = state?.listing_type === 'offer_listing' || elem?.status === AVAILABLE_FOR_OFFER;
              elem.category_settings = {
                ...elem.category_settings,
                ...feedData?.category_settings?.browse_node_id ? {
                  // primary_category: is_offer ? "default" : feedData?.category_settings?.primary_category,
                  // sub_category: is_offer ? "default" : feedData?.category_settings?.secondary_category,
                  browser_node_id: is_offer ? "0" : feedData?.category_settings?.browse_node_id,
                  displayPath: is_offer ? "Default" : feedData?.category_settings?.category_fullpath?.split(" > ")
                } : {},
                product_type: is_offer ? 'PRODUCT' : categoryProductType.product_type,
                attributes_mapping: {
                  jsonFeed: feedData?.data,
                  language_tag: feedData?.language_tag,
                  marketplace_id: feedData?.marketplace_id,
                }
              }
              if (!feedData?.category_settings?.browse_node_id)
                elem.unset = {
                  ...elem.unset,
                  "category_settings.primary_category": 1,
                  "category_settings.sub_category": 1,
                  "category_settings.browser_node_id": 1,
                  "category_settings.displayPath": 1,
                }
            } else { // unset category setting, product_type and jsonFeed from parent elem
              elem.unset = {
                ...elem.unset,
                "category_settings.primary_category": 1,
                "category_settings.sub_category": 1,
                "category_settings.browser_node_id": 1,
                "category_settings.displayPath": 1,
                "category_settings.product_type": 1,
                "category_settings.attributes_mapping": 1
              }
            }
          } else { // if variant edit is opened
            elem = {
              ...elem,
              edited_variant_jsonFeed: feedData?.data,
              unset: { // unset category setting and product type from variant edit
                ...elem.unset,
                "category_settings.primary_category": 1,
                "category_settings.sub_category": 1,
                "category_settings.browser_node_id": 1,
                "category_settings.displayPath": 1,
                "category_settings.product_type": 1,
              }
            }
          }
        } else {
          if (!componentState?.product_type?.variantEdit) { // Parent Edit is opened
            delete elem?.category_settings?.product_type
            delete elem?.category_settings?.attributes_mapping?.jsonFeed
            elem.unset = {
              ...elem.unset,
              "category_settings.primary_category": 1,
              "category_settings.sub_category": 1,
              "category_settings.browser_node_id": 1,
              "category_settings.displayPath": 1,
              "category_settings.product_type": 1,
              "category_settings.attributes_mapping": 1,
            }
          } else { // Variant edit is opened
            elem.unset = {
              ...elem.unset,
              "category_settings.primary_category": 1,
              "category_settings.sub_category": 1,
              "category_settings.browser_node_id": 1,
              "category_settings.displayPath": 1,
              "category_settings.language_tag": 1,
              "category_settings.marketplace_id": 1,
              "category_settings.product_type": 1,
              'category_settings.variants_json_attributes_values': 1,
              "edited_variant_jsonFeed": 1,
            }
          }
        }
        return { ...elem };
      })

      dispatch({
        type: ACTION_TYPE.ERRORS,
        payload: { errors: validatedKeys, hasError: hasError },
      });
      setBusinessPriceErrors(JSON.parse(JSON.stringify(businessErrData)));
      setPriceErrors(JSON.parse(JSON.stringify(priceErrData)));
      setQuantityErrors(JSON.parse(JSON.stringify(quantityErrData)));

      if (!hasError && !businessErr && !priceErr && !quantityErr) {
        componentState['loaders']['saveProduct'] = true;
        if (!merge_data[0]?.unset.hasOwnProperty("business_price")) {
          let businessData: any = merge_data[0]?.business_price ?? {};
          if (businessData?.quantity_type == "fixed") {
            businessData['quantity_discount'] = businessData?.['fixed'];
          }
          else {
            businessData['quantity_discount'] = businessData?.['percent'];
          }
          delete businessData?.['fixed'];
          delete businessData?.['percent'];
          merge_data[0]['business_price'] = businessData
        }
        if (merge_data[0]?.unset.hasOwnProperty("business_price")) {
          merge_data[0]['business_price_enabled'] = false;
        }
        if (!merge_data[0]?.unset.hasOwnProperty("price")) {
          let priceData = merge_data[0]?.price ?? {};
          let sanitizedPrice = getSanitizedPrice(priceData);
          let price = 0;
          let pricerules = JSON.parse(JSON.stringify(sanitizedPrice));
          if (sanitizedPrice?.attribute == "custom") {
            price = sanitizedPrice['value'];
          }
          else {
            price = state?.shopify_data?.price ?? 0;
          }
          merge_data[0]['price'] = price;
          merge_data[0]['price_rules'] = pricerules;
        }
        if (!merge_data[0]?.unset.hasOwnProperty("quantity")) {
          let quantityData = merge_data[0]?.quantity ?? {};
          let sanitizedQuantity = getSanitizedQuantity(quantityData);
          let quantity = 0;
          let quantityRules = JSON.parse(JSON.stringify(sanitizedQuantity));
          if (sanitizedQuantity?.effective_inventory?.enabled && sanitizedQuantity?.effective_inventory?.type == "fixed") { // custom wala check na ke fixed
            quantity = sanitizedQuantity?.effective_inventory?.['value'];
          }
          if (sanitizedQuantity?.attribute && sanitizedQuantity?.attribute == "custom") { // custom wala check na ke fixed
            quantity = sanitizedQuantity?.['value'] ?? 0;
          }
          else {
            quantity = state?.shopify_data?.quantity ?? 0;
          }
          merge_data[0]['quantity'] = quantity;
          merge_data[0]['quantity_rules'] = quantityRules;
        }

        merge_data[0]['additional_images'] = merge_data[0]['additional_images']?.filter((ele: string, ind: number) => ele != defaultImage) ?? []

        merge_data[0]['ai_updated_product'] = true;
        merge_data[0]['frontend'] = "new";
        if (merge_data[0]?.category_settings && merge_data[0]?.category_settings?.product_type) {
          merge_data[0]['amazonProductType'] = merge_data[0]?.category_settings?.product_type;
        }

        //new code flow for variants mapping
        if (!componentState?.product_type?.variantEdit) {
          // Extract the first object from merge_data for easy reference
          const firstMergeData = merge_data?.[0];
          const unsetData = firstMergeData?.unset || {}; // Extract `unset` object safely
          const categorySettings = firstMergeData?.category_settings || {}; // Extract `category_settings` safely

          // Check if `unset` contains category settings or product type
          const hasCategorySettings = unsetData.hasOwnProperty("category_settings");
          const hasCategoryProductType = unsetData.hasOwnProperty("category_settings.product_type");

          // Check if `category_settings.variants_value_mapping` exists in `unset`
          const hasVariantMappingUnset = unsetData["category_settings.variants_value_mapping"];

          if (hasCategorySettings || hasCategoryProductType) {
            // If category settings or product type is switched to default
            if (!hasVariantMappingUnset) {
              // If `category_settings.variants_value_mapping` is missing in `unset`, add it
              firstMergeData.unset = {
                ...unsetData,
                "category_settings.variants_value_mapping": 1,
              };
            }
          } else {
            if (Object.keys(variantsValueMapping ?? {}).length > 0) {
              // If `variantsValueMapping` contains data, set it in `category_settings`
              firstMergeData.category_settings = {
                ...categorySettings,
                variants_value_mapping: variantsValueMapping,
              };
            } else {
              // If `variants_value_mapping` exists inside `category_settings`, delete it
              if (categorySettings.hasOwnProperty("variants_value_mapping")) {
                delete firstMergeData.category_settings.variants_value_mapping;
              }

              // If `category_settings.variants_value_mapping` is missing in `unset`, add it
              if (!hasVariantMappingUnset) {
                firstMergeData.unset = {
                  ...unsetData,
                  "category_settings.variants_value_mapping": 1,
                };
              }
            }
          }
        }

        (process.env.REACT_APP_PROD === "0" || isAdminLoggedIn()) && console.log(merge_data, hasChanged, 'merge_data');
        let { success, message, data, other_attributes_error } = await saveproduct(props, merge_data);
        if (success) {
          setHasChanged(false);
          getProduct();
          props.success(t(message));
          props.di.globalState.set('edit_tour_current_step', `${currentStep}`)
          componentState['showSavebar'] = false;
          componentState['mutatedKeys'] = {};
          componentState['onSave'] = {
            message: message,
            data: data,
          };
          setComponentState({ ...componentState });
          setValidatorErrorAfterSave([]);
          setOtherAttributeErrors({});
        } else {
          if (data && data?.length > 0) {
            setValidatorErrorAfterSave(data ?? []);
            setOtherAttributeErrors({});
            props.error(t('Error while saving!'));
            // setRenderJSONFeed(true);
            // setCategoryProductType(a => ({ ...a, currentData: feedData?.data }))
          } else {
            setValidatorErrorAfterSave([]);
            const structuredErrorObj: Record<string, any> = {};
            const newAttributeErrors: Record<string, string> = {};

            for (const errorCode of Object.keys(other_attributes_error)) {
              const message = errorCodeToMessage[errorCode];
              const attributeKey = errorCodeToAttribute[errorCode]; // e.g., "category_settings.barcode_exemption"

              if (attributeKey && message) {
                setNestedValue(structuredErrorObj, attributeKey, true);
                newAttributeErrors[attributeKey] = message;


                // Only scroll to the first one
                if (Object.keys(structuredErrorObj).length === 1) {
                  setTimeout(() => {
                    customExecuteScroll(attributeKey);
                  }, 350);
                }
              }
            }
            // Update with only the new errors
            setOtherAttributeErrors(newAttributeErrors);
            props.error(Object?.values?.(newAttributeErrors)?.[0] ?? t('Error while saving!'));
          }
        }
      } else {
        let errorDetails: any = getErrorBySectionName(validatedKeys, t);
        props.error(t(errorDetails?.message) || t(error_message) || t('Some information is missing or wrong, kindly check them before proceeding.'));
        customExecuteScroll(errorDetails?.scroll_to);
      }
      componentState['loaders']['saveProduct'] = false;
    }
  }

  function customExecuteScroll(type?: any) {
    switch (type) {
      case 'product_type': productTypeRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      case 'title': titleRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      case 'description': descriptionRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      case 'inventory_fulfillment_latency': inventory_fulfillment_latency?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      case 'sku': skuRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      case 'price': priceRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      case 'businessPrice': businessPriceRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      case 'barcode': barcodeRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      case 'image_selection': imageRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      case 'variant_grid': variantGridRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" })
        break;
      default: break;
    }

  }

  useEffect(() => {
    let type: any;
    if (props?.location?.state?.attribute && document.getElementById(props?.location?.state?.attribute)) {
      type = props?.location?.state?.attribute;
      document.getElementById(type)?.scrollIntoView({ behavior: 'smooth' /*or smooth*/, block: 'center' })
    }

  }, [props.location.state, state, imageRef]);

  function onDiscard() {
    setOtherAttributeErrors({});
    setPriceErrors({
      attribute: false,
      value: false,
    });
    setQuantityErrors({
      effective_inventory: false,
      fixed_inventory: false,
      reserved_inventory: false,
      threshold_inventory: false,
      warehouses: false,
      value: false,
      attribute: false
    });
    setBusinessPriceErrors({
      selectionType: false,
      attribute: false,
      value: false,
      quantity_type: false,
      fixed: [{ quantity: false, price: false, touched: { quantity: false, price: false } }],
      percent: [{ quantity: false, price: false, touched: { quantity: false, price: false } }],
    })
    setShowBusinessPrice(false);
    setHasChanged(false);
    setIsOpen(false);
    setCurrentStep(-1);
    getProduct();
    componentState['showSavebar'] = false;
    componentState['mutatedKeys'] = {};
    setComponentState({ ...componentState });  //Restoring states to initial level
    setCategoryProductType({
      product_type: '',
      init_product_type: '',
      suggested_product_types: [],
      loadingSuggestions: false,
      selection_type: "custom",
      init_selection_type: "custom",
      category_data: {}
    });
    dispatch({  //Restoring states to initial level
      type: 'updateAll',
      payload: {
        ...state?.initialComponentState,
        renderComponent: true,
        errors: [],
        displayPath: state?.initialComponentState?.displayPath ?? {}
      },
    });
  }

  function customHeader(): any {
    return (
      <CustomHeader
        loaderHandler={loaderHandler}
        componentState={componentState}
        loader={attributeLoader}
        JSONFeedAttributesData={JSON.parse(JSON.stringify(JSONFeedAttributesData ?? {}))}
      />
    );
  }

  async function uploadImages() {
    if (state?.['upload_image_array']?.length > 0) {
      const formData = new FormData();
      const url = `${environment.API_ENDPOINT}amazon/product/uploadImageInS3Bucket`;
      state?.['upload_image_array'].forEach((image: any) => {
        formData.append('file[]', image);
      })
      const requestHeaders: HeadersInit = new Headers();
      const auth: any = props.di.globalState.getBearerToken();
      requestHeaders.set('Authorization', auth);
      loaderHandler('uploadImage', true);
      await fetch(url, {
        headers: requestHeaders,
        method: 'POST',
        body: formData,
      }).then((response) => response.json())
        .then((data) => {
          let { images, success, message, exceeded_files } = data;
          if (success && images && images?.length > 0) {
            exceeded_files && exceeded_files?.length > 0 && setExceededFiles([]);
            let tempImages: any = [...state?.['myfolder_images']];
            tempImages = [...tempImages, ...images];
            tempImages.uniqueArray()
            dispatch({
              type: ACTION_TYPE.ADD_NEW_SHOPIFY_IMAGES,
              payload: {
                myfolder_images: [...tempImages],
              },
            });
            actionHandler();
            dispatch({
              type: ACTION_TYPE.MODAL_ACTION,
              payload: { open: false },
            });
          }
          else {
            setExceededFiles(exceeded_files ?? []);
            props.error(t('Unable to add image!') + " " + message);
          }
          loaderHandler('uploadImage', false);
        })
        .catch((error: any) => {
          props.error(t(error) ?? t("Oops some error occured while uploading image(s)."))
        });
    }
  }

  function onDataChange() {
    switch (state?.modal?.type) {
      case 'imageupload':
        uploadImages();
        break;
      default:
        break;
    }
  }

  if (componentState?.['loaders']?.['fullPage']) {
    return <FullPageLoader />;
  }

  function primaryAction() {
    let primaryAction: any = null;
    switch (state?.modal?.type) {
      case 'imageupload':
        primaryAction = {
          content: state?.modal.content,
          onAction: uploadImages,
          loading: componentState?.['loaders']?.['uploadImage'],
        };
        break;
      default:
        break;
    }
    return primaryAction;
  }

  function actionHandler() {
    switch (state?.modal?.type) {
      case 'imageupload':
        dispatch({
          type: ACTION_TYPE.UPLOAD_IMAGE_ARRAY,
          payload: {
            [ACTION_TYPE.UPLOAD_IMAGE_ARRAY]: [],
          },
        });
        break;
      default:
        break;
    }
  }

  const scrollToElement = (element: any, offsetTop: number = 150) => {
    let y = element?.getBoundingClientRect()?.top + window.pageYOffset - offsetTop;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  const uploadProduct = () => {
    setMoreActionsData(a => ({ ...a, loader: true }))
    props.di.POST('connector/product/upload', {
      target: {
        marketplace: props?.redux?.current?.target?.marketplace,
        shopId: props?.redux?.current?.target?.['_id'],
      },
      source: {
        marketplace: props?.redux?.current?.source?.marketplace,
        shopId: props?.redux?.current?.source?.['_id'],
      },
      source_product_ids: [componentState?.initialProductData?.source_product_id],
      activePage: 1
    }).then((response) => {
      setMoreActionsData(a => ({ key: null, confirmationData: '', loader: false }))
      if (response?.success) {
        props.success(t(response?.message));
        onDiscard();
      } else {
        props.error(t(response?.message));
      }
    })
  }

  const amazonLookup = () => {
    setMoreActionsData(a => ({ ...a, loader: true }))
    props.di.POST('connector/product/searchProduct', {
      target: {
        marketplace: props?.redux?.current?.target?.marketplace,
        shopId: props?.redux?.current?.target?.['_id'],
      },
      source: {
        marketplace: props?.redux?.current?.source?.marketplace,
        shopId: props?.redux?.current?.source?.['_id'],
      },
      source_product_ids: [componentState?.initialProductData?.source_product_id],
      activePage: 1
    }).then((response) => {
      setMoreActionsData(a => ({ key: null, confirmationData: '', loader: false }))
      if (response?.success) {
        props.success(t(response?.message));
        onDiscard();
      } else {
        props.error(t(response?.message));
      }
    })
  }

  (process.env.REACT_APP_PROD === "0" || isAdminLoggedIn()) && console.log(state, componentState, categoryProductType, hasChanged, 'state');

  const items = () => {
    let item = [
      {
        id: 'fullfilment_type',
        name: t('Fulfilment Type'),
        offer_simple: true,
        new_simple: true,
        offer_parent: true,
        new_parent: true,
        offer_var: true,
        new_var: true,
        content: t('Fulfilment Type'),
      },
      {
        id: 'title',
        name: t('Title'),
        offer_simple: false,
        new_simple: true,
        offer_parent: false,
        new_parent: true,
        offer_var: false,
        new_var: true,
        content: t('Product Title'),
      },
      {
        id: 'description',
        name: t('Description'),
        offer_simple: false,
        new_simple: true,
        offer_parent: false,
        new_parent: true,
        offer_var: false,
        new_var: true,
        content: t('Description'),
      },
      {
        id: 'inventory_fulfillment_latency',
        name: t('Handling Time'),
        offer_simple: false,
        new_simple: true,
        offer_parent: false,
        new_parent: true,
        offer_var: false,
        new_var: true,
        content: t('Handling Time'),
      },
      {
        id: 'price',
        name: t('Price'),
        offer_simple: true,
        new_simple: true,
        offer_parent: true,
        new_parent: true,
        offer_var: true,
        new_var: true,
        content: t('Price'),
      },
      {
        id: 'businessPrice',
        name: t('Business Price'),
        offer_simple: true,
        new_simple: true,
        offer_parent: true,
        new_parent: true,
        offer_var: true,
        new_var: true,
        content: t('Business Price'),
      },
      {
        id: 'inventory',
        name: t('Inventory'),
        offer_simple: true,
        new_simple: true,
        offer_parent: true,
        new_parent: true,
        offer_var: true,
        new_var: true,
        content: t('Inventory'),
      },
      {
        id: 'sku',
        name: t('Amazon Parent SKU'),
        offer_simple: false,
        new_simple: false,
        offer_parent: false,
        new_parent: true,
        offer_var: false,
        new_var: false,
        content: t('Amazon Parent SKU'),
      },
      {
        id: 'sku',
        name: t('Amazon Variant SKU'),
        offer_simple: false,
        new_simple: false,
        offer_parent: false,
        new_parent: false,
        offer_var: true,
        new_var: true,
        content: t('Amazon Variant SKU'),
      },
      {
        id: 'sku',
        name: t('Amazon SKU'),
        offer_simple: true,
        new_simple: true,
        offer_parent: false,
        new_parent: false,
        offer_var: false,
        new_var: false,
        content: t('Amazon SKU'),
      },
      {
        id: 'barcode',
        name: t('Barcode / GTIN Exemption'),
        offer_simple: false,
        new_simple: true,
        offer_parent: false,
        new_parent: true,
        offer_var: false,
        new_var: false,
        content: t('Barcode / GTIN Exemption'),
      },
      {
        id: 'barcode',
        name: t('Barcode'),
        offer_simple: true,
        new_simple: false,
        offer_parent: false,
        new_parent: false,
        offer_var: true,
        new_var: true,
        content: t('Barcode'),
      },
      {
        id: 'product_type',
        name: t('Product Type'),
        offer_simple: false,
        new_simple: true,
        offer_parent: false,
        new_parent: true,
        offer_var: false,
        new_var: false,
        content: t('Product Type'),
      },
      {
        id: 'attributes',
        name: t('Attributes'),
        offer_simple: true,
        new_simple: categoryProductType.selection_type === "custom",
        offer_parent: true,
        new_parent: categoryProductType.selection_type === "custom",
        offer_var: true,
        new_var: true,
        content: t('Attributes'),
      },
      {
        id: 'image_selection',
        name: t('Images'),
        offer_simple: false,
        new_simple: true,
        offer_parent: false,
        new_parent: true,
        offer_var: false,
        new_var: true,
        content: t('Images'),
      },
      {
        id: 'variants',
        name: t('Variants'),
        offer_simple: false,
        new_simple: false,
        offer_parent: true,
        new_parent: true,
        offer_var: false,
        new_var: false,
        content: t('Variants'),
      },
    ]
    item = item.filter((i) => {
      let listing_type = state?.listing_type;
      let product_type = componentState?.product_type?.variantEdit ? "variant" : componentState?.initialProductData?.type === 'simple' ? "simple" : "parent";
      let show = false;
      const { offer_simple, new_simple, offer_parent, new_parent, offer_var, new_var } = i;

      if (listing_type === 'new_listing') {
        show = product_type === "variant" ? new_var : product_type === 'simple' ? new_simple : new_parent;
      } else {
        show = product_type === "variant" ? offer_var : product_type === 'simple' ? offer_simple : offer_parent;
      }
      return show
    })
    return [...item]
  }

  const button1: any = <InlineStack gap="100" blockAlign='center'>
    <span className='custom-amz-redirect__btn'><ShopifyIcon /></span>
    <div className='Custom__Icon--Fill'>
      <Icon
        source={ExternalMinor}
        tone="base"
      />
    </div>
  </InlineStack>;

  const button2: any = <InlineStack gap="100" blockAlign='center'>
    <span className='custom-amz-redirect__btn flex'><AmazonIcon /></span>
    <div className='Custom__Icon--Fill'>
      <Icon
        source={ExternalMinor}
        tone="base"
      />
    </div>
  </InlineStack>;

  return (
    <>
      {
        <StateContext.Provider value={state}>
          <DispatchContext.Provider value={dispatch}>
            <ContainerState.Provider
              value={{
                containerState: componentState,
                setContainerState: setComponentState,
                loaderHandler: loaderHandler,
                categoryProductType,
                setCategoryProductType,
                JSONFeedAttributesData,
                setJSONFeedAttributesData,
                renderJSONFeed,
                setRenderJSONFeed,
                allProductTypes,
                customExecuteScroll,
                onDiscard
              }}>
              {isPageLoading(componentState) && <LoadingE />}
              <div className='Custom__Page--Header'>
                <Page
                  fullWidth={screen.width > 1920}
                  backAction={{
                    content: t('Products'),
                    onAction: () => {
                      props.history(-1);
                      props.di.globalState.removeLocalStorage('edit_tour_current_step')
                    },
                    accessibilityLabel: 'Edit_Product__backAction'
                  }}
                  title={componentState?.['initialProductData']?.title ?? ''}
                  titleMetadata={<div className='Custom__Product--Btn'>
                    <InlineStack gap="200" wrap={false} blockAlign="center">
                      <Badge tone={getAmazonStatus(componentState.initialProductData?.['status'] ?? '')}>
                        {componentState.initialProductData?.['status']}
                      </Badge>
                      <Button target='_blank' url={componentState?.['initialProductData']?.['viewOnShopify']} size='micro'>{button1}</Button>
                      <Button disabled={!(componentState?.initialProductData?.asin && componentState?.initialProductData?.asin?.length == 10 && /^[a-zA-Z][a-zA-Z0-9]*$/.test(componentState?.initialProductData?.asin))} url={`http://${getAmazonLink(props)}/dp/${componentState.initialProductData.asin}`} target='_blank' size='micro' >{button2}</Button>
                    </InlineStack>
                  </div>}
                  subtitle={state?.initialComponentState?.variants?.length > 0 ? `${state?.initialComponentState?.variants?.length} variant(s)` : ''}
                  compactTitle
                  primaryAction={<InlineStack gap='400' blockAlign='start' wrap={false}>
                    <RenderHeadersAction {...props} show_only_lng_switcher />
                  </InlineStack>}
                  actionGroups={[
                    {
                      title: t('More Actions'),
                      actions: [
                        {
                          content: t('Upload Product'),
                          accessibilityLabel: 'UploadEditProduct',
                          onAction: () => {
                            setMoreActionsData({
                              key: 'upload',
                              confirmationData: <BlockStack gap='100'>
                                <Text as='p'>{t("Are you sure you want to upload the product on Amazon?")}</Text>
                                <Text as='p' fontWeight='semibold'>{t("Note: Save all details before uploading.")}</Text>
                              </BlockStack>,
                              loader: false
                            })
                          },
                          disabled: attributeLoader || componentState?.showSavebar,
                          ...componentState?.showSavebar ? { helpText: t('Kindly save you changes before uploading') } : {}
                        },
                        {
                          content: t('Amazon Lookup'),
                          accessibilityLabel: 'AmazonLookupEditProduct',
                          onAction: () => { setMoreActionsData({ key: 'amazonLookup', confirmationData: t('You can choose to run Amazon Lookup on your product you want. This will update the status of this product that are currently under “Not Listed: Offer” status.'), loader: false }) },
                          disabled: attributeLoader || componentState?.showSavebar,
                          ...componentState?.showSavebar ? { helpText: t('Kindly save you changes before initiaing amazon lookup') } : {}
                        },
                        ...props?.location?.state?.errorExists ? [{
                          content: t('View Error(s)'),
                          accessibilityLabel: 'Error(s)',
                          onAction: () => setViewProductError(a => !a),
                          destructive: true
                        }] : [],
                        ...props?.location?.state?.warningExists ? [{
                          content: t('View Warning(s)'),
                          accessibilityLabel: 'Warning(s)',
                          id: "Custom-Popover-Item--warning",
                          onAction: () => setViewProductWarning(a => !a),
                        }] : [],
                      ],
                    }
                  ]}
                >
                  {customHeader()}
                  <ProductErrorsN viewProductError={viewProductError} setViewProductError={setViewProductError} />
                  <ProductWarningsN setViewProductWarning={setViewProductWarning} viewProductWarning={viewProductWarning} />
                  <EditTour {...props} JSONFeedAttributesData={JSONFeedAttributesData} saveJSONData={JSONFeedRef.current} categoryProductType={categoryProductType} />
                  <BlockStack gap='400'>
                    {(componentState['showSavebar'] || hasChanged) &&
                      (process.env.REACT_APP_PROD === "0" ||
                        isAdminLoggedIn()) && (
                        <ContextualSaveBar
                          message={t("Unsaved Changes")}
                          saveAction={{
                            onAction: () => {
                              saveProductData();
                            },
                            loading:
                              componentState['loaders'][
                              'saveProduct'
                              ],
                            disabled: attributeLoader,
                          }}
                          discardAction={{
                            onAction: () => {
                              if (attributeLoader) {
                                props.error(t('Kindly wait, some sections are loading!'))
                              } else
                                onDiscard();
                            },
                            discardConfirmationModal: true,
                          }}
                        />
                      )}
                    <TopTabs items={items} scrollToElement={scrollToElement} />
                    <Provider
                      value={{
                        attributeLoader: attributeLoader,
                        businessPriceErrors: JSON.parse(JSON.stringify(businessPriceErrors)),
                        setBusinessPriceErrors,
                        priceErrors: JSON.parse(JSON.stringify(priceErrors)),
                        setPriceErrors,
                        quantityErrors: JSON.parse(JSON.stringify(quantityErrors)),
                        setQuantityErrors
                      }}
                    >
                      {
                        <Suspense fallback={<FulfilmentTypeSkeleton />}>
                          <FulfillmentType validatorError={otherAttributeErrors} />
                        </Suspense>
                      }
                      {state?.['listing_type'] == 'new_listing' && <Suspense fallback={<ProductTitleSkeleton />}>
                        <div style={props?.location?.state?.attribute == "title" ? style : undefined} id='title' ref={titleRef} className="title">
                          <Title validatorError={otherAttributeErrors} />
                        </div>
                      </Suspense>}
                      {state?.['listing_type'] == 'new_listing' && <Suspense fallback={<DescriptionSkeleton />}>
                        <div ref={descriptionRef} className="description">
                          <Descriptions setHasChanged={setHasChanged} validatorError={otherAttributeErrors} />
                        </div>
                      </Suspense>}
                      {state?.['listing_type'] == 'new_listing' && <Suspense fallback={<HandlingTimeSkeleton />}>
                        <div ref={inventory_fulfillment_latency} className={"inventory_fulfillment_latency"}>
                          <HandlingTimes validatorError={otherAttributeErrors} />
                        </div>
                      </Suspense>}
                      {<Suspense fallback={<PriceSkeleton />}>
                        <div ref={priceRef} className="price">
                          <PriceN validatorError={otherAttributeErrors} />
                        </div>
                      </Suspense>}
                      <Suspense fallback={<BusinessPriceSkeleton />}>
                        <div ref={businessPriceRef} className="businessPrice">
                          <BusinessPriceN
                            setShowBusinessPrice={setShowBusinessPrice}
                            showBusinessPrice={showBusinessPrice}
                          />
                        </div>
                      </Suspense>
                      {/* {(componentState['product_type'][
                        'variantEdit'
                      ] ||
                        !componentState.initialProductData[
                        'hasVariants'
                        ]) &&
                        <Suspense fallback={<InventorySkeleton />}>
                          <div className={'inventory'}>
                            <Quantitys />
                          </div>
                        </Suspense>
                      } */}
                      <Suspense fallback={<InventorySkeleton />}>
                        <div ref={inventoryRef} className="inventory">
                          <QuantityN validatorError={otherAttributeErrors} />
                        </div>
                      </Suspense>
                      {(state?.['listing_type'] == 'new_listing' || componentState['product_type']['variantEdit'] || componentState['initialProductData']['type'] === "simple") && <Suspense fallback={<AmazonSkuSkeleton />}>
                        <div style={props?.location?.state?.attribute == "tour_sku" ? style : undefined} id='sku' ref={skuRef} className="sku">
                          <AmazonParentSkus validatorError={otherAttributeErrors} />
                        </div>
                      </Suspense>}
                      {(state?.['listing_type'] == 'new_listing' || componentState['product_type']['variantEdit'] || componentState['initialProductData']['type'] === "simple") && <Suspense fallback={<BarCodeSkeleton />}>
                        <div style={props?.location?.state?.attribute == "barcode_edit" ? style : undefined} id='barcode_edit' ref={barcodeRef} className="barcode">
                          <BarcodeExemptions validatorError={otherAttributeErrors} />
                        </div>
                      </Suspense>}
                      {state?.['listing_type'] != 'offer_listing' && !componentState['product_type']['variantEdit'] &&
                        <Suspense fallback={<AmazonCategorySkeleton />}>
                          <div
                            style={props?.location?.state?.attribute == "category" && !categoryProductType?.product_type ? style : undefined}
                            id={props?.location?.state?.attribute == "category" && !categoryProductType?.product_type ? 'category' : ''}
                            className="product_type"
                            ref={productTypeRef}
                          >
                            <ProductTypeSelector />
                          </div>
                        </Suspense>}
                      {(componentState?.loaders?.['required_attribute'] || componentState?.loaders?.['shopify_attribute']) ? jsonAttributesSkeleton() :
                        categoryProductType?.product_type && !!JSONFeedAttributesData &&
                        (categoryProductType?.selection_type === "custom" || state?.listing_type === "offer_listing" || componentState['product_type']['variantEdit']) &&
                        <Suspense
                          fallback={jsonAttributesSkeleton()}>
                          <div id='tour_attribute' className="attributes">
                            <JSONFeedAttributes
                              key='editProduct'
                              ref={JSONFeedRef}
                              from={componentState?.product_type?.variantEdit && state?.listing_type === 'new_listing' ? 'variant_edit' : 'product_edit'}
                              getData={{ ...categoryProductType?.getData ?? {} }}
                              parent_loading={componentState?.loaders?.['required_attribute'] && !componentState['product_type']['variantEdit']}
                              onChange={(change: boolean) => {
                                onSaveBarChange(change, "jsonFeed");
                              }}
                              currentData={{ ...categoryProductType?.currentData ?? {} }}
                              product_attributes={componentState?.product_attributes ?? []}
                              category_attributes={{ ...JSONFeedAttributesData }}
                              renderJSONFeed={renderJSONFeed}
                              product_type={categoryProductType?.product_type ?? ''}
                              setRenderJSONFeed={setRenderJSONFeed}
                              savedProductType={categoryProductType?.init_product_type ?? ""}
                              setLoaderForParent={setAttributeLoader}
                              hasVariants={componentState?.initialProductData?.type == "variation"}
                              additionalDataFromEditProd={{
                                products_value_on_shopify: state?.products_value_on_shopify ?? [],
                                shopify_data: state?.shopify_data ?? {},
                                product_type: categoryProductType?.product_type ?? "",
                                validatorErrAfterSave: validatorErrAfterSave,
                                title: state?.data?.title,
                                description: state?.data?.title,
                                category_settings: categoryProductType?.category_data
                              }}
                              variantsValueMapping={variantsValueMapping}
                              setVariantsValueMapping={setVariantsValueMapping}
                              {...props}
                            />
                          </div>
                        </Suspense>}
                      {!categoryProductType?.product_type && componentState['product_type']['variantEdit'] && <Card roundedAbove='sm'>
                        <Layout>
                          <Layout.AnnotatedSection
                            id="producttitle"
                            title={t("Attribute Mapping")}
                            description={t("These are a set of Amazon Attributes that you must map with your Shopify store Product Attributes. You can also set a Custom value for the same as per your requirement.")}
                          >
                            <div className={'Custom-Polaris-Box attributes'}>
                              <Box padding='400' background="bg-surface-secondary" borderRadius='300' borderWidth='025' borderColor='border'>
                                <BlockStack gap='400'>
                                  <BlockStack gap='300'>
                                    <Text as='h2' variant='headingMd'>
                                      {t("Add Attributes in Variants")}
                                    </Text>
                                    <Text as='p'>
                                      {t("Any additional attributes you want to add to your attributes list.")}
                                    </Text>
                                    <div>
                                      <Button
                                        disabled
                                        icon={<div><Icon source={MobilePlusMajor} tone="base" /></div>}>
                                        {t("Add Optional Attributes")}
                                      </Button>
                                    </div>
                                  </BlockStack>
                                  <Banner tone='warning'>{t("No Attributes found, because")}:
                                    <li>{t("There is no product type saved in parent product.")}</li>
                                    <li>{t("Barcode is not available.")}</li>
                                  </Banner>
                                </BlockStack>
                              </Box>
                            </div>
                          </Layout.AnnotatedSection>
                        </Layout>
                      </Card>}

                      {/* {state?.['listing_type'] == 'new_listing' && <div ref={image}>
                        <Suspense fallback={<ImageSkeleton />}>
                          <div style={props?.location?.state?.attribute == "image" ? style : undefined} id='image' ref={imageRef} className="image_selection">
                            <Images />
                          </div>
                        </Suspense>

                      </div>} */}

                      {state?.['listing_type'] == 'new_listing' && <div ref={image}>
                        <Suspense fallback={<NewImageSkeleton />}>
                          <div style={props?.location?.state?.attribute == "image" ? style : undefined} id='image' ref={imageRef} className="image_selection">
                            <UpdatedImage validatorError={otherAttributeErrors} />
                          </div>
                        </Suspense>
                      </div>}

                      {!componentState['product_type'][
                        'variantEdit'
                      ] &&
                        componentState.initialProductData[
                        'hasVariants'
                        ] && (
                          <Suspense fallback={variantGridSkeleton(t)}>
                            <div ref={variantGridRef} className="variants">
                              <VariantsGrid errorExists={props?.location?.state?.errorExists ?? false} />
                            </div>
                          </Suspense>
                        )}
                    </Provider>
                    <Modal
                      primaryAction={primaryAction()}
                      size={
                        state?.modal?.type ===
                          'knowmoreonuploadingimages' ? 'large' : undefined
                      }
                      open={state?.modal?.open ?? false}
                      title={state?.modal?.title}
                      onClose={function (): void {
                        dispatch({
                          type: ACTION_TYPE.MODAL_ACTION,
                          payload: { open: false },
                        });
                        actionHandler();
                      }}>
                      <Modal.Section>
                        <BlockStack gap={"300"}>
                          <BlockStack gap={"150"}>
                            <Text as='p' variant='headingSm'>Things to keep in mind</Text>
                            <Box paddingInlineEnd={{ xs: '0', sm: '0', md: '2000', lg: '2000', xl: '2000' }}>
                              <List>
                                <List.Item>
                                  <Text as='p' variant='bodyMd' tone='subdued'>Upload images in the supported formats: PNG, JPEG, and GIF and should not exceed a size of 1 MB.</Text>
                                </List.Item>
                                <List.Item>
                                  <Text as='p' variant='bodyMd' tone='subdued'>
                                    You cannot upload more than 5 images at once.
                                  </Text>
                                </List.Item>
                              </List>
                            </Box>
                          </BlockStack>
                          {getModalStructure(
                            state.modal?.['type'],
                            t,
                            [],
                            onDataChange,
                            exceededFiles,
                          )}
                        </BlockStack>
                      </Modal.Section>
                    </Modal>
                    <Modal
                      open={moreActionsData.key !== null}
                      title={t('Confirmation Required')}
                      onClose={() => { setMoreActionsData(a => ({ ...a, key: null, confirmationData: '' })) }}
                      primaryAction={{
                        content: t('Confirm'),
                        loading: moreActionsData.loader,
                        accessibilityLabel: 'confirm' + moreActionsData.key,
                        onAction() {
                          if (moreActionsData.key === 'upload') uploadProduct();
                          if (moreActionsData.key === 'amazonLookup') amazonLookup();
                        }
                      }}
                    >
                      <Modal.Section>
                        {typeof moreActionsData.confirmationData === 'string' ? <Text as='p'>{moreActionsData.confirmationData}</Text> : moreActionsData.confirmationData}
                      </Modal.Section>
                    </Modal>
                  </BlockStack>
                </Page>
              </div>
            </ContainerState.Provider>
          </DispatchContext.Provider>
        </StateContext.Provider >
      }
      {renderFooter(props, t)}

      <Modal
        open={showToastForLongLoading}
        onClose={() => {
          props.error(t("Seems like we are having some trouble in loading the attributes. Let's try a quick refresh to fix it."));
        }}
        title={t("We couldn't load the attributes")}
        primaryAction={{
          content: t('Refresh data'),
          onAction: () => {
            setAttributeLoader(true);
            getCategoryAttributes();
          },
          loading: attributeLoader
        }}>
        <Modal.Section>
          <BlockStack gap='300'>
            <BlockStack gap='200' inlineAlign='center'>
              <Image source={RefreshAttributes} alt='' width={200} />
            </BlockStack>
            <Text as='p' tone='subdued'>{t("Seems like we are having some trouble in loading the attributes. Let's try a quick refresh to fix it.")}</Text>
          </BlockStack>
        </Modal.Section>
      </Modal>
    </>)
}

export default DI(Editproduct);

export interface CategoryProductTypeI {
  product_type: string,
  init_product_type: string,
  selection_type: "default" | "custom",
  init_selection_type: "default" | "custom"
  getData?: any,
  currentData?: any,
  product_type_changed?: string,
  suggested_product_types: string[],
  loadingSuggestions: boolean,
  from?: 'edited' | 'profile',
  category_data: any
}

export function populateSelectedImages(
  field: string = '',
  addUptoIndex: number = 9
) {
  let tempArry: any = [];
  for (let i = 0; i < addUptoIndex; i++) {
    tempArry.push(defaultImage);
  }
  return [...tempArry];
}